<ng-container *ngIf="viewSize == 'large'">
  <div class="hpanel">
    <div class="panel-body pad-cus border-radius-top-left-right-6 hover-border-v2" [ngClass]="getJobCssClasses()">
      <div class="lg-job-candidate-card-container-v2">

        <!-- Left Section - Owner Details -->
        <div class="lg-job-candidate-card-user-detail-v2">
          <div style="position: relative; right: 15px;" *ngIf="showCheckBox==true" class="custom-checkbox-v2"
            title="Select Jobs to see its activity">
            <label class="checkbox-label font-normal">
              <input id="candidate_card_select_checkbox" type="checkbox" (click)="selectCheckbox1($event,candidateval)"
                [(ngModel)]="candidateval.isSelected"
                (ngModelChange)="onNgModelChange($event , candidateval?.candidateId)" name="list_name" />
              <span class="checkmark" style="top: -5px"></span>
            </label>
          </div>

          <div class="owner-section-v2">
            <div class="owner-profile-img-v2" style="position: relative;">
              <!-- Role Badges -->
              <span class="label label-success ui-align-role-v2"
                *ngIf="candidateval?.user?.userType == 'FREELANCE_RECRUITER'" title="Freelance Recruiter">FR</span>
              <span class="label label-success ui-align-role-v2" *ngIf="candidateval?.user?.userType == 'student'"
                title="Student">ST</span>
              <span class="label label-success ui-align-role-v2" *ngIf="candidateval?.user?.userType == 'JOB_SEEKER'"
                title="Job Seeker">JS</span>
              <span class="label label-success ui-align-role-v2"
                *ngIf="candidateval?.user?.userType!= 'FREELANCE_RECRUITER' && candidateval?.user?.userType!= 'student' && candidateval?.user?.userType!= 'JOB_SEEKER' && candidateval?.user?.workExperience?.clientType == 'Vendor'"
                title="Vendor">V</span>
              <span class="label label-success ui-align-role-v2"
                *ngIf="candidateval?.user?.userType!= 'FREELANCE_RECRUITER' && candidateval?.user?.userType!= 'student' && candidateval?.user?.userType!= 'JOB_SEEKER' && candidateval?.user?.workExperience?.clientType == GigsumoConstant.DIRECT_HIRE"
                title="Direct Hire">DH</span>
              <span class="label label-success ui-align-role-v2"
                *ngIf="candidateval?.user?.userType!= 'FREELANCE_RECRUITER' && candidateval?.user?.userType!= 'student' && candidateval?.user?.userType!= 'JOB_SEEKER' && candidateval?.user?.workExperience?.clientType == 'Systems Integrator'"
                title="Systems Integrator">SI</span>
              <span class="label label-success ui-align-role-v2"
                *ngIf="candidateval?.user?.userType!= 'FREELANCE_RECRUITER' && candidateval?.user?.userType!= 'student' && candidateval?.user?.userType!= 'JOB_SEEKER' && candidateval?.user?.workExperience?.clientType == 'Prime Vendor'"
                title="Prime Vendor">PV</span>
              <span class="label label-success ui-align-role-v2"
                *ngIf="candidateval?.user?.userType!= 'FREELANCE_RECRUITER' && candidateval?.user?.userType!= 'student' && candidateval?.user?.userType!= 'JOB_SEEKER' && candidateval?.user?.workExperience?.clientType == 'Staffing Agency'"
                title="Staffing Agency">SA</span>
              <span class="label label-success ui-align-role-v2"
                *ngIf="candidateval?.user?.userType!= 'FREELANCE_RECRUITER' && candidateval?.user?.userType!= 'student' && candidateval?.user?.userType!= 'JOB_SEEKER' && candidateval?.user?.workExperience?.clientType == 'Direct Client'"
                title="Direct Client">DC</span>
              <span class="label label-success ui-align-role-v2"
                *ngIf="candidateval?.user?.userType!= 'FREELANCE_RECRUITER' && candidateval?.user?.userType!= 'student' && candidateval?.user?.userType!= 'JOB_SEEKER' && candidateval?.user?.workExperience?.clientType == 'Supplier'"
                title="Supplier">SP</span>

              <!-- Profile Image/Initials -->
              <div *ngIf="!resumerequsetuser&&candidateval?.user?.photo!=undefined">
                <img *ngIf="candidateval?.user?.photo!=undefined" src="{{candidateval?.user?.photo}}"
                  alt="profile-picture">
              </div>
              <div *ngIf="!resumerequsetuser&&candidateval?.user?.photo == undefined">
                <div class="circles" [style.background-color]="getColor(candidateval?.user?.fullname)">
                  <div class="circle-text pad-22" [style.color]="getFullNameTextColor(candidateval?.user?.fullname)"
                  style="font-weight: bold;">
                    {{ getInitials(candidateval?.user?.fullname) }}
                  </div>
                </div>
              </div>
              <div *ngIf="resumerequsetuser&&resumerequsetuser?.photo != undefined">
                <img *ngIf="resumerequsetuser?.photo!=undefined" src="{{url+resumerequsetuser?.photo}}"
                  alt="profile-picture">
              </div>
              <div *ngIf="resumerequsetuser && resumerequsetuser?.photo == undefined">
                <div class="circles"
                  [style.background-color]="getColortwo(resumerequsetuser?.firstName, resumerequsetuser?.lastName)">
                  <div class="circle-text"
                    [style.color]="getTextColor(resumerequsetuser?.firstName, resumerequsetuser?.lastName)">
                    {{ getInitialstwo(resumerequsetuser?.firstName, resumerequsetuser?.lastName) }}
                  </div>
                </div>
              </div>
            </div>

            <div class="owner-info-v2">
              <div class="custom-checkbox-v2" *ngIf="candidateval.currentStatus != 'APPLIED' && filtersApplied"
                title="Select Candidate">
                <input class="check-btn-ui check-ui" (change)="selectCheckbox()" type="checkbox"
                  value="{{candidateval?.user?.userId}}" [(ngModel)]="candidateval.isSelected" name="list_name" />
              </div>

              <h6
                title="{{ pageName !== 'job-invite-sent' ? candidateval?.user?.fullname : (resumerequsetuser?.firstName + ' ' + resumerequsetuser?.lastName) }}"
                class="owner-name-v2">
                {{ pageName !== 'job-invite-sent' ? candidateval?.user?.fullname : (resumerequsetuser?.firstName + ' '
                + resumerequsetuser?.lastName) }}
              </h6>

              <!-- Candidate's current organization -->
              <div class="owner-org-name-v2" *ngIf="hasCurrentOrganization">
                <span *ngFor="let work of candidateval?.user?.workExperience">
                  <span *ngIf="work?.currentOrganization" title="{{work?.organisationName}}">
                    {{work?.organisationName}}
                  </span>
                </span>
              </div>

              <!-- Job posted on behalf of (for job cards) -->
              <div class="owner-org-name-v2" *ngIf="candidateval.jobPostedBehalfOf != 'null'"
                title="{{candidateval.jobPostedBehalfOf}}">
                {{candidateval.jobPostedBehalfOf}}
              </div>

              <div class="owner-timestamp-v2" *ngIf="candidateval.postedOn">
                {{candidateval?.postedOn | timezoneDate:'MM/dd/yyyy'}}
              </div>
              <div class="owner-timestamp-v2" *ngIf="candidateval.updatedOn">
                {{candidateval?.updatedOn | timezoneDate:'MM/dd/yyyy'}}
              </div>
            </div>
          </div>
        </div>

        <!-- Middle Section - Candidate Details -->
        <div class="lg-job-candidate-card-detail-v2">
          <div class="candidate-header-v2" id="candidate_card_primary_show_button">
            <div class="candidate-name-section-v2">
              <div class="lg-candidate-name-v2"
                [class.marketplace-candidate-name]="From === 'SUGGESTED_CANDIDATES' || pageName === 'suggested-candidates'"
                [class.featured-candidate-name]="From === 'FEATURED_CANDIDATE'"
                *ngIf="candidateval?.firstName!=null"
                title="{{candidateval.firstName|titlecase }} {{ candidateval.lastName|titlecase }}"
                (click)="open(candidateval)">
                {{candidateval.firstName|titlecase}} {{ candidateval.lastName|titlecase }}
              </div>

              <div class="candidate-experience-v2">
                Experience: {{candidateval.totalExperience}} Years
              </div>
            </div>

            <div class="urgent-hire-container" *ngIf="getActiveUrgencyDays(candidateval) as urgencyDays">
              <span class="urgent-hire-badge"><ng-icon name="tablerFlame" class="urgent-hire-icon"></ng-icon> Hot</span>
            </div>

            <!-- Job Title and Skills Section -->
            <div class="candidate-skills-container-v2">
              <div class="candidate-job-title-v2" *ngIf="candidateval?.jobTitle" title="{{candidateval.jobTitle}}">
                {{candidateval.jobTitle}}
              </div>
              <div class="candidate-skills-v2" *ngIf="getFlattenedSkills(candidateval?.primarySkills) as flatPrimarySkills">
                <div *ngFor="let data of (candidateval?.skillsExpanded ? flatPrimarySkills : flatPrimarySkills.slice(0, 3)); let i = index;">
                  <div title="{{data}}" class="skill-badge-v2">{{data}}</div>
                </div>

                <!-- More button -->
                <div class="skill-more-btn-v2"
                     *ngIf="flatPrimarySkills.length > 3"
                     (click)="toggleSkills(candidateval); $event.stopPropagation()">
                  <span *ngIf="!candidateval?.skillsExpanded">+{{flatPrimarySkills.length - 3}} more</span>
                  <span *ngIf="candidateval?.skillsExpanded">Show less</span>
                </div>
              </div>
            </div>
          </div>

          <div id="candidate_card_details_button" class="candidate-details-grid-v2" (click)="open(candidateval)">
            <div class="detail-item-v2" title="{{candidateval.clientName}}" *ngIf="candidateval.showClientName">
              <ng-icon name="tablerBuilding" class="svg-position"></ng-icon>
              {{candidateval.clientName | truncate:20}}
            </div>

            <div class="detail-item-v2" *ngIf="candidateval.city || candidateval.state">
              <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
              <span title="{{candidateval.city}}">{{candidateval.city}}</span>
              <span title="{{candidateval.state}}" *ngIf="candidateval.state">, {{candidateval.state}}</span>
            </div>

            <div class="detail-item-v2"
              title="{{candidateval.targetRate}} , {{candidateval.country}} , {{candidateval.payType}}">
              <ng-container *ngIf="candidateval?.targetRateFrom && candidateval?.targetRateTo; else noRateCandLarge">
                <span title="{{candidateval.targetRateFrom}} - {{candidateval.targetRateTo}}">
                  {{candidateval.country == 'US' ? "$" : ""}} {{candidateval.targetRateFrom}} -
                  {{candidateval.targetRateTo}}
                </span>
                <span title="{{candidateval.country}}" *ngIf="candidateval?.country == 'US'"> USD / </span>
                <span title="{{candidateval.country}}" *ngIf="candidateval?.country == 'IN'"> INR / </span>
                <span title="{{candidateval.country}}" *ngIf="candidateval?.country == 'CA'"> CAD / </span>
                <span title="{{candidateval.country}}" *ngIf="candidateval?.country == 'AU'"> AUD / </span>
                <span title="{{candidateval.country}}"
                  *ngIf="candidateval?.country != 'AU' && candidateval?.country != 'US' && candidateval?.country != 'CA' && candidateval?.country != 'IN'">
                  CUR / </span>
                <value-template #valueProvider="handleValue">
                  <span title="{{valueProvider.getValue(candidateval)}}">{{valueProvider.getValues(candidateval)}}</span>
                </value-template>
              </ng-container>
              <ng-template #noRateCandLarge><span title="Rate: Not available">$ Not available</span></ng-template>
            </div>

            <div *ngIf="candidateval?.workMode=='Onsite'" class="detail-item-v2" title="Onsite">
              <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
              Onsite
            </div>
            <div *ngIf="candidateval?.workMode=='Remote'" class="detail-item-v2" title="Remote">
              <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
              Remote
            </div>
            <div *ngIf="candidateval?.workMode=='Hybrid'" class="detail-item-v2" title="Hybrid">
              <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
              Hybrid
            </div>

            <div *ngIf="candidateval.resumeAttached && candidateval.createdBy==userId" class="detail-item-v2">
              <ng-icon name="tablerId"></ng-icon> Attached
            </div>
          </div>

          <!-- Interactive Elements -->
          <!-- <div class="interactive-elements-v2" [ngClass]="{'disabled': filtersApplied==true}"> -->
            <!-- Views -->
            <!-- <div id="candidate_card_views_button"
              *ngIf="candidateval.createdBy==userId && candidateval.viewedByCount > 0"
              (click)="goTo(candidateval, 'views')">
              <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
              <span title="{{candidateval.viewedByCount}} Views" class="blue-color">{{ candidateval.viewedByCount | compactCount }}</span>
              Views
            </div>

            <div id="candidate_card_no_views_button" title="0 Views"
              *ngIf="candidateval.createdBy==userId && candidateval.viewedByCount == 0"
              (click)="goTo(candidateval, 'Noviews')">
              <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
              <span class="blue-color" title="{{candidateval.viewedByCount}} Views">0</span> Views
            </div>

            <div *ngIf="candidateval.createdBy!=userId && candidateval.viewedByCount > 0" class="no-interaction-v2">
              <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
              <span class="blue-color" title="{{candidateval.viewedByCount}} Views">{{ candidateval.viewedByCount | compactCount }}</span>
              Views
            </div>

            <div title="0 Views" *ngIf="candidateval.createdBy!=userId && candidateval.viewedByCount == 0"
              class="no-interaction-v2">
              <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
              <span class="blue-color" title="{{candidateval.viewedByCount}} Views">0</span> Views
            </div> -->

            <!-- Like Button -->
            <!-- <div id="candidate_card_like_button" *ngIf="candidateval?.isLiked != null" (click)="like(candidateval)">
              <ng-icon name="tablerHeart" class="pointer md-interaction-element" [ngClass]="candidateval.isLiked ? 'bg-heart liked-v2' : 'icon-prime-color'"></ng-icon>
            </div> -->
             <div class="interactive-elements-v2" [ngClass]="{'disabled': filtersApplied==true}">
            <!-- Views -->
            <div id="candidate_card_views_button" title="{{ candidateval.viewedByCount }} Views"
              *ngIf="candidateval.createdBy==userId && candidateval.viewedByCount > 0" (click)="goTo(candidateval, 'views')">
              <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
              <span class="blue-color">{{ candidateval.viewedByCount | compactCount }}</span>
              Views
            </div>
         
            <div id="candidate_card_no_views_button" title="0 Views"
              *ngIf="candidateval.createdBy==userId && candidateval.viewedByCount == 0" (click)="goTo(candidateval, 'Noviews')">
              <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
              <span class="blue-color">0</span> Views
            </div>
         
            <div title="{{ candidateval.viewedByCount }} Views"
              *ngIf="candidateval.createdBy!=userId && candidateval.viewedByCount > 0" class="no-interaction-v2">
              <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
              <span class="blue-color">{{ candidateval.viewedByCount | compactCount }}</span>
              Views
            </div>
         
            <div title="0 Views" *ngIf="candidateval.createdBy!=userId && candidateval.viewedByCount == 0"
              class="no-interaction-v2">
              <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
              <span class="blue-color">0</span> Views
            </div>

            <!-- Likes Count -->
            <!-- <div title="Likes" [ngStyle]="{'cursor': candidateval.createdBy!=userId ? 'context-menu' : 'pointer'}">
              <span id="candidate_card_likes_count_button" class="blue-color"
                *ngIf="candidateval.likesCount>0 && candidateval.createdBy==userId"
                (click)="goTo(candidateval, 'Clike-like')">{{candidateval.likesCount}}</span>
              <span class="blue-color"
                *ngIf="candidateval.likesCount>0 && candidateval.createdBy!=userId">{{candidateval.likesCount}}</span>
              <span id="candidate_card_likes_text_button" (click)="goTo(candidateval, 'Clike-like')"
                *ngIf="candidateval.likesCount>0 && candidateval.createdBy==userId"> Like<span
                  *ngIf="candidateval.likesCount>1">s</span></span>
              <span
                *ngIf="candidateval.likesCount>0 && candidateval.createdBy!=userId"> Like<span
                  *ngIf="candidateval.likesCount>1">s</span></span>
              <div title="0 Likes" class="no-interaction-v2"
                *ngIf="candidateval.likesCount == 0 && candidateval.createdBy!=userId">
                <span class="blue-color" title="0 Likes">0</span> Like
              </div>
              <div id="candidate_card_zero_likes_button" title="0 Likes"
                *ngIf="candidateval.likesCount == 0 && candidateval.createdBy==userId"
                (click)="goTo(candidateval, 'Clike-like')">
                <span class="blue-color" title="0 Likes">0</span> Like
              </div>
            </div> -->

               <div style="display: flex; align-items: center; gap: 4px;">
 
              <!-- Like Button -->
              <div id="candidate_card_like_button" *ngIf="candidateval?.isLiked != null" (click)="like(candidateval)">
                <ng-icon name="tablerHeart" class="pointer md-interaction-element"
                  [ngClass]="candidateval.isLiked ? 'bg-heart liked-v2' : 'icon-prime-color'">
                </ng-icon>
              </div>
 
              <!-- Likes Count -->
              <div [title]="candidateval.likesCount + (candidateval.likesCount === 1 ? ' Like' : ' Likes')"
                   [ngStyle]="{'cursor': candidateval.createdBy != userId ? 'context-menu' : 'pointer'}">
 
                <span id="candidate_card_likes_count_button" class="blue-color"
                  *ngIf="candidateval.likesCount > 0 && candidateval.createdBy == userId"
                  (click)="goTo(candidateval, 'Clike-like')">
                  {{ candidateval.likesCount | compactCount }}
                </span>
 
                <span class="blue-color" *ngIf="candidateval.likesCount > 0 && candidateval.createdBy != userId">
                  {{ candidateval.likesCount | compactCount }}
                </span>
 
                <span id="candidate_card_likes_text_button"
                  *ngIf="candidateval.likesCount > 0 && candidateval.createdBy == userId"
                  (click)="goTo(candidateval, 'Clike-like')">
                  Like<span *ngIf="candidateval.likesCount > 1">s</span>
                </span>
 
                <span *ngIf="candidateval.likesCount > 0 && candidateval.createdBy != userId">
                  Like<span *ngIf="candidateval.likesCount > 1">s</span>
                </span>
 
                <div title="0 Likes" class="no-interaction-v2"
                  *ngIf="candidateval.likesCount == 0 && candidateval.createdBy != userId">
                  <span class="blue-color" title="0 Likes">0</span> Like
                </div>
 
                <div id="candidate_card_zero_likes_button" title="0 Likes"
                  *ngIf="candidateval.likesCount == 0 && candidateval.createdBy == userId"
                  (click)="goTo(candidateval, 'Clike-like')">
                  <span class="blue-color" title="0 Likes">0</span> Like
                </div>
 
              </div>
 
            </div>

            <!-- Invites -->
            <div id="candidate_card_invites_button" (click)="goTo(candidateval, 'cInvited')"
              title="Invites Received Count" *ngIf="candidateval.createdBy==userId">
              <ng-icon name="tablerMail" class="svg-position"></ng-icon>
              <span class="blue-color"
                *ngIf="candidateval.interestShownCount>0">{{ candidateval.interestShownCount | compactCount }}</span>
              <span *ngIf="candidateval.interestShownCount==0">0</span>
              <span class="blue-color" *ngIf="candidateval.appliedToday>0">({{candidateval.appliedToday}} new)</span>
              Invites
            </div>

            <!-- Jobs Applied -->
            <div id="candidate_card_jobs_applied_button" (click)="goTo(candidateval, 'jobsApplied')"
              title="Job Applied Count" *ngIf="candidateval.createdBy === userId">
              <ng-icon name="tablerSend"></ng-icon>
              <span class="blue-color"
                *ngIf="candidateval?.jobsAppliedCount > 0">{{ candidateval?.jobsAppliedCount | compactCount }}</span>
              <span *ngIf="candidateval?.jobsAppliedCount === 0">0</span>
              <span class="blue-color" *ngIf="candidateval.appliedToday>0">({{candidateval.appliedToday}} new)</span>
              Applied
            </div>

            <!-- Download Resume -->
            <ng-container *ngFor="let item of candidateval?.resumes">
              <div *ngIf="item?.isDefault">
                <a id="candidate_card_download_resume_button"
                  (click)="downloadResume(candidateval,userId,item.fileId)" target="_blank" download>
                  <ng-icon name="tablerDownload" class="icon-prime-color"></ng-icon> Download Resume
                </a>
              </div>
            </ng-container>

            <div *ngIf="candidateval.createdBy==userId && candidateval?.resumes?.length==0">
              <a><ng-icon name="tablerPaperclip" class="icon-prime-color"></ng-icon> Attach Resume</a>
            </div>

            <!-- Get Resume -->
            <div id="candidate_card_request_resume_button"
              (click)="requestResume(candidateval , null, connectionTemplate, jobsupplytemplate)"
              *ngIf="shouldShowGetResume(candidateval)&& candidateval.createdBy!=userId && (userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')">
              <a class="get-resume-icon-v2">
                <ng-icon name="tablerFile" class="icon-prime-color"></ng-icon>Get Resume
              </a>
            </div>

            <div *ngIf="shouldShowRequested(candidateval)" class="resume-requested-v2">
              <a download><ng-icon name="tablerCheck" style="color: #8B5CF6;"></ng-icon> Resume Requested</a>
            </div>

            <!-- Invite to Apply -->
            <ng-container *ngIf="!inviteapplyhide|| inviteapplyhide==undefined">
              <div id="cd-invites" title="Invite to Apply"
                (click)="invite(candidateval, connectionTemplate,jobsupplytemplate)"
                *ngIf="candidateval.createdBy!=userId && (userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')">
                <ng-icon name="tablerMail" class="svg-position"></ng-icon>
                Invite To Apply
              </div>
            </ng-container>

            <!-- Chat -->
            <div id="candidate_card_chat_button" *ngIf="candidateval.chatHistoryCount>0"
              (click)="openMessagecheckInteraction(candidateval, connectionTemplate)"
              title="{{candidateval.nonSeenMessageCount > 0 ? candidateval.nonSeenMessageCount + ' Messages' : 'No Messages'}}">               <span class="chat-icon-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
              <span class="noti-badge noti-chat-i"*ngIf="candidateval.nonSeenMessageCount>0" >{{candidateval.nonSeenMessageCount}}</span>
             </span>
              Chat
            </div>

            <div id="candidate_card_chat_no_messages_button"
              *ngIf="candidateval.createdBy!=userId && candidateval.chatHistoryCount == 0"
              (click)="openMessagecheckInteraction(candidateval, connectionTemplate)"
              title="No Messages">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
              Chat
            </div>

            <div *ngIf="candidateval.createdBy==userId && candidateval.chatHistoryCount == 0" class="no-interaction-v2"
              title="No Messages">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
              Chat
            </div>
          </div>
        </div>

        <!-- Right Section - Status -->
        <div class="lg-job-candidate-card-status-v2">
          <div class="status-section-v2">
            <!-- Status Dropdown Button -->
            <div class="btn-group" dropdown id="jb_dpDown"
              [ngClass]="{'disabled': filtersApplied || jobStatus !='ACTIVE'}" *ngIf="showStatus">
              <button id="candidate_card_status_dropdown_button" dropdownToggle
                (click)="triggerChange(candidateval.candidateId)"
                class="btn status-button-v2 status-action-btn fRCard dropdown-toggle" aria-expanded="true"
                [ngStyle]="getStyle(candidateval.currentStatus)">
                <span *ngIf="candidateval.currentStatus!=null">{{candidateval.currentStatus|titlecase}}</span>
                <span *ngIf="candidateval.currentStatus==null">Applied</span>
                <ng-container *ngIf="pageName=='job-applicants' && !isExcludedStatus(candidateval.currentStatus)">
                  <ng-icon name="tablerChevronDown" class="arrowclasspad" style="margin-top: 2px; margin-right: 5px;"
                    aria-hidden="true"></ng-icon>
                </ng-container>
              </button>

              <ng-container *ngIf="pageName=='job-applicants' && !isExcludedStatus(candidateval.currentStatus)">
                <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  style="right: -131px; left: auto; margin-top: -117px;" aria-labelledby="button-animated">
                  <li role="menuitem" *ngIf="candidateval.currentStatus!='SHORTLISTED'"
                    (click)="updatestatus('SHORTLISTED',candidateval)" id="SHORTLISTED">
                    <a id="SHORTLISTED"><ng-icon name="tablerCircle" class="fs-status-icon t-short" aria-hidden="true"></ng-icon>&nbsp; Shortlisted</a>
                  </li>
                  <li role="menuitem" *ngIf="candidateval.currentStatus!='REJECTED'"
                    (click)="updatestatus('REJECTED',candidateval)" id="REJECTED">
                    <a id="REJECTED"><ng-icon name="tablerCircle" class="fs-status-icon t-inActive" aria-hidden="true"></ng-icon>&nbsp; Rejected</a>
                  </li>
                  <li role="menuitem" *ngIf="candidateval.currentStatus!='INTERVIEW SCHEDULED'"
                    (click)="updatestatus('INTERVIEW SCHEDULED',candidateval)" id="INTERVIEW SCHEDULED">
                    <a id="INTERVIEW SCHEDULED"><ng-icon name="tablerCircle" class="fs-status-icon t-filled" aria-hidden="true"></ng-icon>&nbsp; Interview scheduled</a>
                  </li>
                  <li role="menuitem" *ngIf="candidateval.currentStatus!='INTERVIEW REJECTED'"
                    (click)="updatestatus('INTERVIEW REJECTED',candidateval)" id="INTERVIEW REJECTED">
                    <a id="INTERVIEW REJECTED"><ng-icon name="tablerCircle" class="fs-status-icon t-filled" aria-hidden="true"></ng-icon>&nbsp; Interview Rejected</a>
                  </li>
                  <li role="menuitem" *ngIf="candidateval.currentStatus!='SELECTED'"
                    (click)="updatestatus('SELECTED',candidateval)" id="SELECTED">
                    <a id="SELECTED"><ng-icon name="tablerCircle" class="fs-status-icon t-active" aria-hidden="true"></ng-icon>&nbsp;
                      Selected</a>
                  </li>
                  <li role="menuitem" *ngIf="candidateval.currentStatus!='OFFERED'"
                    (click)="updatestatus('OFFERED',candidateval)" id="OFFERED">
                    <a id="OFFERED"><ng-icon name="tablerCircle" class="fs-status-icon t-offer" aria-hidden="true"></ng-icon>&nbsp;
                      Offered</a>
                  </li>
                  <li role="menuitem" *ngIf="candidateval.currentStatus!='PREONBOARDED'"
                    (click)="updatestatus('PREONBOARDED',candidateval)" id="PREONBOARDED">
                    <a id="PREONBOARDED"><ng-icon name="tablerCircle" class="fs-status-icon t-preonboard" aria-hidden="true"></ng-icon>&nbsp; Pre-Onboarding</a>
                  </li>
                  <li role="menuitem" *ngIf="candidateval.currentStatus!='ONBOARDED'"
                    (click)="updatestatus('ONBOARDED',candidateval)" id="ONBOARDED">
                    <a id="ONBOARDED"><ng-icon name="tablerCircle" class="fs-status-icon t-hold" aria-hidden="true"></ng-icon>&nbsp;Onboarded</a>
                  </li>
                  <li role="menuitem" *ngIf="candidateval.currentStatus!='OFFER WITHDRAWN'"
                    (click)="updatestatus('OFFER WITHDRAWN',candidateval)" id="OFFER WITHDRAWN">
                    <a id="OFFER WITHDRAWN"><ng-icon name="tablerCircle" class="fs-status-icon t-withdrawn" aria-hidden="true"></ng-icon>&nbsp; Offer Withdrawn</a>
                  </li>
                  <li role="menuitem" *ngIf="candidateval.currentStatus!='OFFER DECLINED'"
                    (click)="updatestatus('OFFER DECLINED',candidateval)" id="OFFER DECLINED">
                    <a id="OFFER DECLINED"><ng-icon name="tablerCircle" class="fs-status-icon t-close" aria-hidden="true"></ng-icon>&nbsp; Offer declined</a>
                  </li>
                </ul>
              </ng-container>
            </div>

            <!-- Non-dropdown Status Button -->
            <button class="btn btn-xs status-button-v2" *ngIf="!showStatus" type="button"
              [ngStyle]="getStyle(candidateval.currentStatus || candidateval.status)">
              <ng-container *ngIf="candidateval.currentStatus === 'INITIATED'"> Invited </ng-container>
              <ng-container *ngIf="candidateval.currentStatus === 'ACCEPTED'"> Applied </ng-container>
              <ng-container *ngIf="candidateval.status=='ACTIVE' &&candidateval.currentStatus==null"> Available
              </ng-container>
              <ng-container *ngIf="candidateval.status=='INACTIVE' && candidateval.currentStatus==null"> UnAvailable
              </ng-container>
              <ng-container *ngIf="candidateval.status=='DRAFTED'"> Draft </ng-container>
              <ng-container *ngIf="candidateval.status=='BLOCKED'"> Blocked </ng-container>
              <ng-container *ngIf="candidateval.currentStatus === 'INTETEREST_SHOWN'"> Invited </ng-container>
              <ng-container
                *ngIf="candidateval.currentStatus != 'INITIATED'&&candidateval.currentStatus != 'ACCEPTED'">
                {{candidateval.currentStatus|titlecase}}
              </ng-container>
            </button>

            <!-- Other Status Buttons -->
            <ng-container *ngIf="showStatus">
              <button style="background:#e74c3c;"
                *ngIf="candidateval.status=='INACTIVE' && candidateval.currentStatus==null" type="button"
                class="btn btn-warning status-button-v2 status-action-btn dwidth">UnAvailable</button>
              <button *ngIf="candidateval.status=='DRAFTED' && candidateval.currentStatus==null" type="button"
                class="btn btn-warning status-button-v2 status-action-btn dwidth">Draft</button>
              <button style="background:#8B5CF6"
                *ngIf="candidateval.status=='DRAFTED' && candidateval.currentStatus==null" type="button"
                class="btn btn-warning status-button-v2 status-action-btn dwidth">Available</button>
            </ng-container>

            <!-- Action Menu (Owner) -->
            <div class="btn-group action-menu-v2" *ngIf="candidateval.createdBy==userId && !filtersApplied" dropdown>
              <a id="button-animated" dropdownToggle>
                <img src="assets/icon/action.png" class="img-width-dot-icon" />
              </a>
              <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                style="right: 0; left: auto;z-index: 2;" aria-labelledby="button-animated">
                <li role="menuitem">
                  <a id="candidate_card_view_button" (click)="open(candidateval)">View</a>
                </li>
              </ul>
            </div>

            <!-- Action Menu (Non-owner).
                 jobStatus is only set when the card has a job context (applicant screens);
                 elsewhere it stays "" and this menu used to render disabled. Pages with no
                 job behind the card (Marketplace Candidates, Featured Candidates, Activity
                 Feed -> Resume Downloaded) set [actionMenuEnabled] so Report / View work. -->
            <div class="btn-group action-menu-v2"
              [ngClass]="{'disabled': filtersApplied || (jobStatus !='ACTIVE' && !actionMenuEnabled)}"
              *ngIf="candidateval.createdBy!=userId && !filtersApplied" dropdown>
              <a id="button-animated" dropdownToggle>
                <img src="assets/icon/action.png" class="img-width-dot-icon" />
              </a>
              <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                style="right: 0; left: auto;z-index: 2" aria-labelledby="button-animated">
                <li role="menuitem" class="report" *ngIf="reportEnabled"
                  style="display:flex;align-content: space-between;flex-wrap: nowrap;flex-direction: row-reverse;">
                  <app-flag type="CANDIDATE" [id]="candidateval.candidateId" [flagTo]="candidateval.createdBy"
                    [flags]="['Report Candidate as fake.']">
                  </app-flag>
                </li>
                <li role="menuitem">
                  <a id="candidate_card_view_button2" (click)="open(candidateval)">View</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="viewSize == 'medium'">
  <div class="hpanel">
    <div id="jobBody" class="panel-body border-radius-top-left-right-6" [ngClass]="{
      'disabled': !candidateval.availability || candidateval.status !='ACTIVE',
      'pad-0': viewSize == 'medium',
      'highLightList': candidateval.isSelected,
      'featured-background': candidateval?.isFeatured==true}">
      <div class="profile-card pad-10-10-10-10">
        <div class="md-top-section">
          <div class="md-user-img">
            <div *ngIf="candidateval?.user?.photo!=undefined">
              <img *ngIf="candidateval?.user?.photo!=undefined" src={{url+candidateval?.user?.photo}}
                alt="profile-picture">
            </div>
            <div *ngIf="candidateval?.user?.photo == undefined">
              <div class="circle-md" [style.background-color]="getColor(candidateval?.user?.fullname)">
                <div class="circle-text-md" [style.color]="getFullNameTextColor(candidateval?.user?.fullname)">{{
                  getInitials(candidateval?.user?.fullname) }}</div>
              </div>
            </div>
          </div>
          <div class="md-user-info">
            <div class="md-user-info-line-1">
              <h6 class="md-user-name fw-bold" title="{{candidateval?.user?.fullname}}">
                {{candidateval?.user?.fullname}}</h6>
            </div>
            <div class="md-user-info-line-2">
              <div *ngIf="userTypeMap[candidateval?.user?.userType]" class="md-user-type"
                title="{{candidateval?.user?.userType}}">
                {{ userTypeMap[candidateval?.user?.userType] }}
              </div>
              <span *ngIf="hasCurrentOrganization">&#64;</span>
              <span *ngFor="let work of candidateval?.user?.workExperience">
                <div title="{{work?.organisationName}}" class="md-current-org" *ngIf="work?.currentOrganization">
                  <span>{{work?.organisationName}}</span>
                </div>
              </span>
            </div>
            <div class="md-user-info-line-3">
              <ng-icon name="tablerClock"></ng-icon>
                <div class="md-time-stamp">
                  {{ (candidateval?.activityDate ? candidateval.activityDate :
                  candidateval?.resumeRequestLogs?.[0]?.date) | timezoneDate }}
                </div>
            </div>
          </div>
          <div class="md-action-buttons">
            <div class="btn-group" dropdown id="jb_dpDown" [ngClass]="{'disabled': jobStatus !='ACTIVE'}"
              *ngIf="showStatus">
              <button id="candidate_card_medium_status_dropdown_button" style="color:#fff;margin-left:-27px;" data-toggle="dropdown" dropdownToggle
                (click)="triggerChange(candidateval.candidateId)" class="btn   btn-sm dropdown-toggle"
                aria-expanded="true" [ngStyle]="getStyle(candidateval?.currentStatus)">
                <ng-container> {{ getFilterValue(candidateval.currentStatus) |titlecase}} </ng-container>
                <ng-container *ngIf=" pageName === 'job-applicants' && !isExcludedStatus(candidateval?.currentStatus) && candidateval?.canUpdateStatus !== false">
                  <ng-icon name="tablerChevronDown" style="margin-left: 10px;"  aria-hidden="true"></ng-icon>
                </ng-container>
              </button>
              <ng-container *ngIf="pageName === 'job-applicants' && !isExcludedStatus(candidateval?.currentStatus) && candidateval?.canUpdateStatus !== false">
                <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-animated">


                  <li role="menuitem" *ngFor="let statusData of filterApplicant(candidateval?.currentStatus, candidateval?.nextAllowedStatuses)"
                    [class.gs-status-locked]="isStatusLocked(statusData)"
                    [attr.aria-disabled]="isStatusLocked(statusData) ? true : null"
                    [attr.title]="isStatusLocked(statusData) ? 'Managed from Contract Manager' : null"
                    (click)="isStatusLocked(statusData) ? $event.stopPropagation() : updatestatus(statusData , candidateval)" id="{{statusData?.item}}">
                    <a id="{{statusData?.item}}"><ng-icon name="tablerCircle" class="fs-status-icon" aria-hidden="true"></ng-icon>&nbsp;
                      {{statusData?.item}}
                    </a>
                  </li>


                </ul>
              </ng-container>
            </div>

            <button style="color:#fff;" *ngIf="!showStatus" type="button" class="btn btn-sm "
              [ngStyle]="getStyle(candidateval.currentStatus || candidateval?.status)">
              <ng-container *ngIf="candidateval?.currentStatus!=undefined && candidateval?.currentStatus!=null">
                {{getFilterValue(candidateval?.currentStatus || candidateval?.status , "CANDIDATE_INVITED") |
                titlecase}} </ng-container>
              <ng-container *ngIf="candidateval?.currentStatus === undefined || candidateval?.currentStatus === null">
                {{ candidateval.status| titlecase}} </ng-container>

            </button>

            <!-- <button class="btn btn-primary" (click)="openDocuments()">
              Documents
              <span *ngIf="totalMandatoryDocuments !== null && totalMandatoryDocuments !== undefined" 
                    class="document-count-badge">
                {{totalMandatoryDocuments}}
              </span>

            </button> -->

            <ng-container *ngIf="showStatus">
              <button style="background:#e74c3c;"
                *ngIf="candidateval.status=='INACTIVE' && candidateval.currentStatus==null" type="button"
                class="btn btn-warning status-action-btn md-action-buttons">UnAvailable</button>
              <button *ngIf="candidateval.status=='DRAFTED' && candidateval.currentStatus==null" type="button"
                class="btn btn-warning status-action-btn md-action-buttons">Draft</button>
              <button style="background:#8B5CF6"
                *ngIf="candidateval.status=='DRAFTED' && candidateval.currentStatus==null" type="button"
                class="btn btn-warning status-action-btn md-action-buttons">Available</button>
            </ng-container>
            <div class="btn-group" *ngIf="candidateval.createdBy==userId && !filtersApplied" dropdown>

              <ng-icon name="tablerDotsVertical" dropdownToggle class="svg-position cursor-pointer" *ngIf="!isRoutingDisabled"></ng-icon>
              <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                style="right: 0; left: auto;z-index: 2;" aria-labelledby="button-animated">
                <li role="menuitem">
                  <a id="candidate_card_medium_view_button" (click)="open(candidateval)">
                    View
                  </a>
                </li>
              </ul>
            </div>
            <div class="btn-group pull-right" [ngClass]="{'disabled': filtersApplied || jobStatus !='ACTIVE'}"
              *ngIf="candidateval.createdBy!=userId && !filtersApplied" dropdown>

              <ng-icon name="tablerDotsVertical" dropdownToggle class="svg-position cursor-pointer" *ngIf="!isRoutingDisabled"></ng-icon>
              <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                style="right: 0; left: auto;z-index: 2" aria-labelledby="button-animated">
                <li role="menuitem" class="report" *ngIf="reportEnabled"
                  style="display:flex;align-content: space-between;flex-wrap: nowrap;flex-direction: row-reverse;">
                  <app-flag type="CANDIDATE" [id]="candidateval.candidateId" [flagTo]="candidateval.createdBy"
                    [flags]="['Report Candidate as fake.']">
                  </app-flag>
                </li>
                <li role="menuitem">
                  <a id="candidate_card_medium_view_button2" (click)="open(candidateval)">
                    View
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="md-bottom-section" style="position: relative;top: 3px">
          <div class="col-sm-2 md-btn-container">
            <div *ngIf="showCheckBox==true" class="custom-checkbox" title="Select Jobs to see its activity">
              <label class="checkbox-label font-normal">
                <input id="candidate_card_medium_select_checkbox" type="checkbox" (click)="selectCheckbox1($event,candidateval)"
                  [(ngModel)]="candidateval.isSelected"
                  [disabled]="(selectedcandiCount>=allowedJobCandidateCounts && candidateval.isSelected==false && isDowngraded) "
                  (ngModelChange)="onNgModelChange($event , candidateval?.candidateId)" name="list_name" />
                <span class="checkmark" style="top: -5px"></span>
              </label>
            </div>
          </div>
          <div id="candidate_card_medium_content_button" class="col-sm-10 md-job-route-content-candidate mr-23" [ngClass]="{'click-blocked': isRoutingDisabled}"
            (click)="open(candidateval)">
            <div class="md-name-skill-container">
              <ng-icon name="tablerUser" class="svg-position"></ng-icon>

              <div class="md-candidate-name"
                title=" {{candidateval.firstName|titlecase }} {{ candidateval.lastName|titlecase }}">
                {{ (candidateval.firstName | titlecase) }} {{ (candidateval.lastName | titlecase) }}

              </div>

              <div [ngStyle]="getStyle(candidateval?.status)" class="br-pd-1" *ngIf="shouldShowStatusText()">
                {{ getStatusText() }}
              </div>
              <div class="md-candidate-skill">
                <div class="btn-group jobProfileBtngp text-wrapsfilter">
                  <div style="display: flex; column-gap: 0.5rem;" *ngIf="candidateval?.primarySkills?.length==1">
                    <div *ngFor="let data of candidateval?.primarySkills; let i = index;">
                      <div title="{{data}}" class="ioxlp-1-ele">
                        {{data}}
                      </div>
                    </div>
                  </div>
                  <div style="display: flex; column-gap: 0.5rem;" *ngIf="candidateval?.primarySkills?.length==2">
                    <div *ngFor="let data of candidateval?.primarySkills; let i = index;">
                      <div title="{{data}}" class="ioxlp-2-ele">
                        {{data}}
                      </div>
                    </div>
                  </div>
                  <div style="display: flex; column-gap: 0.5rem;" *ngIf="candidateval?.primarySkills?.length==3">
                    <div *ngFor="let data of candidateval?.primarySkills; let i = index;">
                      <div title="{{data}}" class="ioxlp-3-ele">
                        {{data}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="md-candidate-details-container">

              <div class="md-candidate-title" title="{{candidateval.jobTitle}}">
                {{candidateval.jobTitle}}
              </div>
              <div class="urgent-hire-container" *ngIf="getActiveUrgencyDays(candidateval) as urgencyDays">
                <span class="urgent-hire-badge"><ng-icon name="tablerFlame" class="urgent-hire-icon"></ng-icon> Hot</span>
              </div>
              <div class="md-experience"> Experience : {{
                candidateval.totalExperience }} Years</div>

              <div class="md-details">
                <div class="md-client-name" *ngIf="candidateval.showClientName">
                  <div class="mb-5" title="{{candidateval.clientName}}">
                    <ng-icon name="tablerBuilding" class="svg-position"></ng-icon>
                    {{candidateval.clientName | truncate:20}}
                  </div>
                </div>
                <div class="md-client-type" *ngIf="candidateval?.clientType!=null">
                  <div title=" {{candidateval.clientType}}">
                    {{candidateval.clientType}}
                  </div>
                </div>
                <div class="md-client-location">
                  <div class="mb-5">
                    <ng-icon name="tablerMapPin" *ngIf="candidateval.city || candidateval.state" class="svg-position"></ng-icon>

                    <span title="{{candidateval.city}}">{{candidateval.city}}</span>
                    <span title="{{candidateval.state}}" *ngIf="candidateval.state"> , {{candidateval.state}}</span>
                  </div>
                </div>

                <div title="Employer Estimate: {{candidateval?.targetRateFrom}} - {{candidateval?.targetRateTo}}"
                  *ngIf="candidateval?.targetRateFrom!=undefined && candidateval?.targetRateTo!=undefined"
                  class="md-job-pay">
                  Employer estimate:
                  <span>
                    {{candidateval?.country === 'US' ?
                    '$' :
                    ''}} {{candidateval?.targetRateFrom}} - {{candidateval?.targetRateTo}}</span>

                  <span title="{{candidateval.country}}" *ngIf="candidateval?.country == 'US'"> USD / </span>
                  <span title="{{candidateval.country}}" *ngIf="candidateval?.country == 'IN'"> INR / </span>
                  <span title="{{candidateval.country}}" *ngIf="candidateval?.country == 'CA'"> CAD / </span>
                  <span title="{{candidateval.country}}" *ngIf="candidateval?.country == 'AU'"> AUD / </span>
                  <span title="{{candidateval.country}}"
                    *ngIf="candidateval?.country != 'AU' && candidateval?.country != 'US' && candidateval?.country != 'CA' && candidateval?.country != 'IN'">
                    CUR / </span>
                  <span title="{{candidateval.payType}}" *ngIf="candidateval?.payType == 'Hourly'">Hr</span>
                  <span title="{{candidateval.payType}}" *ngIf="candidateval?.payType == 'Daily'">Day</span>
                  <span title="{{candidateval.payType}}" *ngIf="candidateval?.payType == 'Weekly'">Week</span>
                  <span title="{{candidateval.payType}}" *ngIf="candidateval?.payType == 'Monthly'">Month</span>
                  <span title="{{candidateval.payType}}" *ngIf="candidateval?.payType == 'Yearly'">Year</span>
                  <div *ngIf="candidateval.resumeAttached && candidateval.createdBy==userId"> <ng-icon name="tablerId"></ng-icon>
                    Attached </div>
                </div>
                <div *ngIf="candidateval?.workMode=='Onsite'" class="mb-5" title="Onsite">
                  <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                  Onsite
                </div>
                <div *ngIf="candidateval?.workMode=='Remote'" class="mb-5" title="Remote">
                  <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                  Remote
                </div>
                <div *ngIf="candidateval?.workMode=='Hybrid'" class="mb-5" title="Hybrid">
                  <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                  Hybrid
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showTimeline == true" class="timeline-section-001">
        <!-- SINGLE NGFOR HORIZONTAL TIMELINE - NO FLICKERING -->
        <div class="horizontal-timeline-004" *ngIf="!timelineIsLoading && mergedTimelineData.length > 0">
          <div class="timeline-event-004" *ngFor='let item of mergedTimelineData; let i = index'>
            <div class="event-card-004" 
                  [ngClass]="{
                    'event-positive-004': item.notion === 'positive',
                    'event-negative-004': item.notion === 'negative', 
                    'event-progress-004': item.notion === 'progress',
                    'event-future-004': item.notion === 'future',
                    'event-default-004': item.notion === 'default'
                  }">
              <div class="event-badge-004"
                    [ngClass]="{
                      'badge-positive-004': item.notion === 'positive',
                      'badge-negative-004': item.notion === 'negative',
                      'badge-progress-004': item.notion === 'progress',
                      'badge-future-004': item.notion === 'future',
                      'badge-default-004': item.notion === 'default'
                    }">
                <!-- Show icons for completed events -->
                <span *ngIf="item.showIcon && item.notion === 'positive'" class="event-icon-004">✓</span>
                <span *ngIf="item.showIcon && item.notion === 'progress'" class="event-icon-004">•</span>
                <span *ngIf="item.showIcon && item.notion === 'negative'" class="event-icon-004">✕</span>
                <!-- Show numbers for future/default events -->
                <span *ngIf="item.showNumber">{{item.order + 1}}</span>
              </div>
              <div class="event-content-004">
                <div class="event-title-004" title="{{item.title}}">
                  {{item.title}}
                </div>
                <div class="event-date-004" *ngIf="item.showDate && item.createdOn">
                  ({{item.createdOn | timezoneDate:'MM/dd/yyyy'}})
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Loading state with skeletons -->
        <div class="horizontal-timeline-004" *ngIf="timelineIsLoading">
          <div class="timeline-skeleton-004" *ngFor="let n of [1, 2, 3, 4, 5,6,7]">
            <app-common-skeleton [NameOftheScreen]="'timeline'"></app-common-skeleton>
          </div>
        </div>
      </div>

      <div class="md-interaction-section"
        [ngClass]="{'disabled': jobStatus !== '' && jobStatus !== 'ACTIVE', 'click-blocked': isRoutingDisabled}">

        <div *ngIf="candidateval.createdBy == userId">
          <div id="candidate_card_small_views_button" *ngIf="candidateval.viewedByCount > 0" (click)="goTo(candidateval, 'views')"
            class="md-interaction-element viewable">
            <ng-icon name="tablerEye" class="icon-prime-color"></ng-icon>
            <span title="{{candidateval.viewedByCount}} Views" class="blue-color">
              {{ candidateval.viewedByCount | compactCount }}
            </span> Views
          </div>
          <div id="candidate_card_small_no_views_button" *ngIf="candidateval.viewedByCount == 0" (click)="goTo(candidateval, 'Noviews')"
            class="md-interaction-element viewable">
            <ng-icon name="tablerEye" class="icon-prime-color"></ng-icon>
            <span class="blue-color">0</span> Views
          </div>
        </div>

        <div *ngIf="candidateval.createdBy != userId">
          <div *ngIf="candidateval.viewedByCount > 0" class="md-interaction-element"
            style="cursor: context-menu!important;">
            <ng-icon name="tablerEye" class="icon-prime-color"></ng-icon>
            <span class="blue-color" title="{{candidateval.viewedByCount}} Views">
              {{ candidateval.viewedByCount | compactCount }}
            </span> Views
          </div>
          <div *ngIf="candidateval.viewedByCount == 0" class="md-interaction-element non-viewable">
            <ng-icon name="tablerEye" class="icon-prime-color"></ng-icon>
            <span class="blue-color">0</span> Views
          </div>
        </div>
        <!-- Like/Unlike Heart Icon -->
        <div id="candidate_card_small_like_button" *ngIf="candidateval?.isLiked != null" (click)="like(candidateval)">
          <ng-icon name="tablerHeart" class="pointer md-interaction-element" [ngClass]="candidateval.isLiked ? 'bg-heart liked' : 'icon-prime-color'"></ng-icon>
        </div>

        <!-- Likes Count and Action -->
        <div id="candidate_card_small_likes_button" class="md-interaction-element" (click)="goTo(candidateval, 'Clike-like')"
          *ngIf="candidateval?.isLiked != null && candidateval.createdBy == userId">
          <span [title]="candidateval.likesCount + ' Likes'" class="blue-color">{{ candidateval.likesCount | compactCount }}</span>
          <span> Like<span *ngIf="candidateval.likesCount > 1">s</span></span>
        </div>

        <!-- Likes Count for Non-Creators -->
        <div class="md-interaction-element" style="cursor: context-menu;"
          *ngIf="candidateval?.isLiked != null && candidateval.createdBy != userId">
          <span [title]="candidateval.likesCount + ' Likes'" class="blue-color">{{ candidateval.likesCount | compactCount }}</span>
          <span> Like<span *ngIf="candidateval.likesCount > 1">s</span></span>
        </div>
        <div id="candidate_card_small_jobs_applied_button" class="md-interaction-element"
          [title]="candidateval.createdBy == userId ? 'Jobs Applied Count' : 'Jobs Applied Count'"
          (click)="candidateval.createdBy == userId ? goTo(candidateval, 'jobsApplied') : null">
          <ng-icon name="tablerSend"></ng-icon>
          <span class="blue-color">{{ candidateval.jobsAppliedCount | compactCount }}</span>
          <span class="blue-color" *ngIf="candidateval.appliedToday > 0">
            {{ candidateval.createdBy == userId ? candidateval.appliedToday : '(' + candidateval.appliedToday + ' new)'
            }}
          </span>
          Applied
        </div>
        <div id="candidate_card_small_invites_button" class="md-interaction-element"
          *ngIf="candidateval.createdBy == userId && (candidateval.interestShownCount >= 0 || candidateval.appliedToday > 0)"
          (click)="goTo(candidateval, 'cInvited')" title="Invites Received Count">
          <ng-icon name="tablerMail" class="svg-position"></ng-icon>
          <span class="blue-color">{{ candidateval.interestShownCount | compactCount }}</span>
          <span class="blue-color" *ngIf="candidateval.appliedToday > 0">({{ candidateval.appliedToday }} new)</span>
          Invites
        </div>

        <div class="md-interaction-element" *ngIf="candidateval?.resumes">
          <ng-container *ngFor="let item of candidateval?.resumes">
            <div *ngIf="item?.isDefault"> <a id="candidate_card_small_download_resume_button" (click)="downloadResume(candidateval,userId,item.fileId)" target="_blank"
                download> <ng-icon name="tablerDownload" class="icon-prime-color"></ng-icon> Download Resume </a>
            </div>
          </ng-container>
        </div>

        <div *ngIf="candidateval.createdBy==userId && candidateval?.resumes?.length==0" class="md-interaction-element">
          <div> <a>
              <ng-icon name="tablerPaperclip" class="icon-prime-color"></ng-icon> Attach Resume </a>
          </div>
        </div>

        <div id="candidate_card_small_request_resume_button" (click)="requestResume(candidateval , null, connectionTemplate, jobsupplytemplate)" class="md-interaction-element" 
        *ngIf="shouldShowGetResume(candidateval)&& candidateval.createdBy!=userId && (userType == 'RECRUITER'
                  || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')">
          <a class="get-resume-icon">
            <ng-icon name="tablerFile" class="icon-prime-color"></ng-icon>Get Resume</a>
        </div>

        <div style="cursor:context-menu;" class="md-interaction-element" download *ngIf="shouldShowRequested(candidateval)"> 
            <ng-icon name="tablerCheck" class="icon-prime-color"></ng-icon> 
            <span>
              Resume Requested 
            </span>
        </div>
        <ng-container *ngIf="!inviteapplyhide|| inviteapplyhide==undefined">
          <div class="md-interaction-element pd-7" id="cd-invites" title="Invite to Apply"
          (click)="invite(candidateval, connectionTemplate,jobsupplytemplate)"
          *ngIf="candidateval.createdBy!=userId && (userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')">
            <ng-icon name="tablerMail"></ng-icon>
            <span>
              Invite
            </span>
          </div>
        </ng-container>

        <div id="candidate_card_small_chat_button" *ngIf="candidateval.chatHistoryCount>0" class="chat-box-icon md-interaction-element"
          (click)="openMessagecheckInteraction(candidateval, connectionTemplate)" title="{{candidateval.nonSeenMessageCount}} Messages">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="gs-icon-action" _ngcontent-serverapp-c3="" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          <span class="blue-color">{{candidateval.nonSeenMessageCount}} </span>
          Chat
        </div>
        <div id="candidate_card_small_chat_no_messages_button" *ngIf="candidateval.createdBy!=userId && candidateval.chatHistoryCount == 0"
          (click)="openMessagecheckInteraction(candidateval, connectionTemplate)" class="md-interaction-element" title="No Messages"
          style="cursor: context-menu;"> <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          Chat
        </div>
        <div *ngIf="candidateval.createdBy==userId && candidateval.chatHistoryCount == 0" class="chat-box-icon"
          title="{{candidateval.nonSeenMessageCount}} Messages"> <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          Chat
        </div>
      </div>      
    </div>
  </div>
</ng-container>


<ng-container *ngIf="viewSize == 'timelineprograssbar'">
  <div class="compact-table-wrapper time-lineprograssbar-view">
    <div class="compact-candidate-row">
      
      <!-- Single Row Layout - All elements horizontally aligned -->
      <div class="table-row-content">
        
        <!-- Rank Column -->
        <div class="col-rank">
          <div class="rank-circle">{{candidateval.rank || 1}}</div>
        </div>
        
        <!-- Candidate Info Column -->
        <div class="col-candidate">
          <div class="candidate-info-compact">
            <div class="name-title-compact">
              <span class="name-compact">{{ (candidateval.firstName | titlecase) }} {{ (candidateval.lastName | titlecase) }}</span>
              <span class="arrow-icon" *ngIf="candidateval?.user?.userType == 'JOB_SEEKER'"> </span>
            </div>
            <div class="details-compact">
              <span class="detail-item">{{candidateval.jobTitle || 'Full Stack Engineer'}}</span>
              <p class="detail-item">{{candidateval.totalExperience}} + Years</p>
            </div>
          </div>
        </div>
        
        <!-- Title & Location Column -->
        <div class="col-location">
          <div class="location-compact">
            <span class="location-full">
              <span *ngIf="candidateval.city">{{candidateval.city}}</span><span *ngIf="candidateval.city && candidateval.state">, </span><span *ngIf="candidateval.state">{{candidateval.state}}</span><span *ngIf="(candidateval.city || candidateval.state) && candidateval.country">, </span><span *ngIf="candidateval.country">{{candidateval.country}}</span>
              <span *ngIf="!candidateval.city && !candidateval.state && !candidateval.country" class="no-location">Location not specified</span>
            </span>
            <span class="availability">Available: {{candidateval.availableIn || candidateval.availability || '2 weeks'}}</span>
          </div>
          <div class="work-mode-compact" *ngIf="candidateval?.workMode">
            <span class="work-mode-badge">{{candidateval?.workMode}}</span>
          </div>
        </div>
        
        <!-- Skills Column -->
        <div class="col-skills">
          <div class="skills-compact-text-container">
            <!-- Collapsed View - Show only one skill + count -->
            <div class="skills-compact-text-collapsed" *ngIf="!candidateval?.skillsExpanded && candidateval?.primarySkills?.length > 0">
              <span class="skill-text-dynamic-compact" [style.background]="getSkillColor(candidateval?.primarySkills[0], true)">{{candidateval?.primarySkills[0]}}</span>
              <span id="candidate_card_compact_expand_skills_button" class="skill-count-text-compact" (click)="toggleSkills(candidateval)"
                    *ngIf="getTotalSkillsCount(candidateval) > 1">
                +{{getTotalSkillsCount(candidateval) - 1}}
              </span>
            </div>

            <!-- Expanded View - Show all skills -->
            <div class="skills-compact-text-expanded" *ngIf="candidateval?.skillsExpanded">
              <div class="skills-row-text" *ngIf="candidateval?.primarySkills?.length > 0">
                <span class="skill-text-dynamic-compact" *ngFor="let skill of candidateval?.primarySkills" [style.background]="getSkillColor(skill, true)">{{skill}}</span>
              </div>
              
              <div class="skills-row-text" *ngIf="candidateval?.secondarySkills?.length > 0">
                <span class="skill-text-dynamic-compact" *ngFor="let skill of candidateval?.secondarySkills" [style.background]="getSkillColor(skill, true)">{{skill}}</span>
              </div>
              
              <span id="candidate_card_compact_collapse_skills_button" class="skill-collapse-text-compact" (click)="toggleSkills(candidateval)">Less</span>
            </div>
          </div>
        </div>
        
        <!-- Match Column -->
        <div class="col-match">
          <div class="match-score">
            <span class="match-percent">{{candidateval.matchScore || 88}}%</span>
            <span id="candidate_card_compact_match_icon_button" class="match-icon" (click)="open(candidateval)"><ng-icon name="tablerExternalLink"></ng-icon>
            </span>
          </div>
        </div>


         <!-- Engagement Column -->
        <div class="col-engagement">
        
          <div class="md-action-buttons">
            <div class="btn-group" dropdown container="body" id="jb_dpDown" [ngClass]="{'disabled': jobStatus !='ACTIVE'}" *ngIf="showStatus">
              <button id="candidate_card_compact_status_dropdown_button" style="color:#fff;margin-left:-27px;" dropdownToggle
                (click)="triggerChange(candidateval.candidateId)" class="btn btn-sm dropdown-toggle" aria-expanded="false"
                [ngStyle]="getStyle(candidateval?.currentStatus)">
                <ng-container> {{ getFilterValue(candidateval.currentStatus) |titlecase}} </ng-container>
                <ng-container *ngIf=" pageName === 'job-applicants' && !isExcludedStatus(candidateval?.currentStatus) && candidateval?.canUpdateStatus !== false">
                  <ng-icon name="tablerChevronDown" style="margin-left: 10px;"  aria-hidden="true"></ng-icon>
                </ng-container>
              </button>
              <ng-container  *ngIf="pageName === 'job-applicants' && !isExcludedStatus(candidateval?.currentStatus) && candidateval?.canUpdateStatus !== false">
                <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu dropdown-menu-right" style="z-index: 99999 !important; position: absolute !important;" role="menu"
                  aria-labelledby="button-animated">
        
        
                  <li role="menuitem" *ngFor="let statusData of filterApplicant(candidateval?.currentStatus, candidateval?.nextAllowedStatuses)"
                    [class.gs-status-locked]="isStatusLocked(statusData)"
                    [attr.aria-disabled]="isStatusLocked(statusData) ? true : null"
                    [attr.title]="isStatusLocked(statusData) ? 'Managed from Contract Manager' : null"
                    (click)="isStatusLocked(statusData) ? $event.stopPropagation() : updatestatus(statusData , candidateval)" id="{{statusData?.item}}">
                    <a id="{{statusData?.item}}"><ng-icon name="tablerCircle" class="fs-status-icon" aria-hidden="true"></ng-icon>&nbsp;
                      {{statusData?.item}}
                    </a>
                  </li>
        
        
                </ul>
              </ng-container>
            </div>
        
            <button style="color:#fff;" *ngIf="!showStatus" type="button" class="btn btn-sm "
              [ngStyle]="getStyle(candidateval.currentStatus || candidateval?.status)">
              <ng-container *ngIf="candidateval?.currentStatus!=undefined && candidateval?.currentStatus!=null">
                {{getFilterValue(candidateval?.currentStatus || candidateval?.status , "CANDIDATE_INVITED") |
                titlecase}} </ng-container>
              <ng-container *ngIf="candidateval?.currentStatus === undefined || candidateval?.currentStatus === null">
                {{ candidateval.status| titlecase}} </ng-container>
        
            </button>
            <ng-container *ngIf="showStatus">
              <button style="background:#e74c3c;" *ngIf="candidateval.status=='INACTIVE' && candidateval.currentStatus==null"
                type="button" class="btn btn-warning status-action-btn md-action-buttons">UnAvailable</button>
              <button *ngIf="candidateval.status=='DRAFTED' && candidateval.currentStatus==null" type="button"
                class="btn btn-warning status-action-btn md-action-buttons">Draft</button>
              <button style="background:#8B5CF6" *ngIf="candidateval.status=='DRAFTED' && candidateval.currentStatus==null"
                type="button" class="btn btn-warning status-action-btn md-action-buttons">Available</button>
            </ng-container>
          
          </div>
        
        
        </div>
        
        <!-- Engagement Column -->
        <div class="col-engagement">
          <div class="engagement-stats">
            <span [title]="(candidateval.viewedByCount || 3) + ' Views'" class="stat-compact">
              <ng-icon name="tablerEye"></ng-icon> {{ (candidateval.viewedByCount || 3) | compactCount }} Views
            </span>
            <span [title]="candidateval.likesCount + ' Likes'" class="stat-compact" *ngIf="candidateval?.isLiked != null">
              <ng-icon name="tablerHeart" [ngClass]="{'liked': candidateval.isLiked}"></ng-icon> {{ candidateval.likesCount | compactCount }} Like
            </span>
          </div> 
          
        </div>
        
        <!-- Quick Actions Column -->
        <div class="col-actions">
          <div class="quick-actions">
            <!-- Resume download button -->
            <ng-container *ngFor="let resume of candidateval?.resumes">
              <button id="candidate_card_compact_download_resume_button" class="action-icon"
                      *ngIf="resume?.isDefault && candidateval.createdBy!=userId"
                      (click)="downloadResume(candidateval,userId,resume.fileId)"
                      title="Download Resume">
                <ng-icon name="tablerDownload"></ng-icon>
              </button>
            </ng-container>
            <!-- Show disabled download if no resume or user is owner -->
            <button class="action-icon" 
                    *ngIf="!candidateval?.resumes?.length || candidateval.createdBy==userId"
                    title="No Resume Available" disabled>
              <ng-icon name="tablerDownload" style="opacity: 0.3;"></ng-icon>
            </button>
            <button id="candidate_card_compact_view_profile_button" class="action-icon" (click)="open(candidateval)" title="View Profile">
              <ng-icon name="tablerEye"></ng-icon>
            </button>
            <button id="candidate_card_compact_send_message_button" class="action-icon" title="Send Message">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
            </button>
            <button class="action-icon" id="candidate_card_compact_documents_button"
              (click)="openDocuments()" title="Candidate Document">
              <ng-icon name="tablerFileDescription"></ng-icon>
            </button>
            <button id="candidate_card_compact_more_options_button" class="action-icon" title="More Options">
              <ng-icon name="tablerDots"></ng-icon>
            </button>
          </div>
        </div>
        
      </div>
      
      <!-- Compact Timeline with Small Rounds -->
      <div class="timeline-compact">
        <div class="timeline-steps">
          <div class="step-item" [ngClass]="{'completed': isStepCompleted('APPLIED', candidateval), 'active': getCurrentStep(candidateval) === 'APPLIED'}">
            <div class="step-circle"></div>
            <span class="step-label">Applied</span>
          </div>
          <div class="step-connector" [ngClass]="{'completed': isStepCompleted('SHORTLISTED', candidateval)}"></div>
          <div class="step-item" [ngClass]="{'completed': isStepCompleted('SHORTLISTED', candidateval), 'active': getCurrentStep(candidateval) === 'SHORTLISTED'}">
            <div class="step-circle"></div>
            <span class="step-label">Shortlisted</span>
          </div>
          <div class="step-connector" [ngClass]="{'completed': isStepCompleted('INTERVIEW SCHEDULED', candidateval)}"></div>
          <div class="step-item" [ngClass]="{'completed': isStepCompleted('INTERVIEW SCHEDULED', candidateval), 'active': getCurrentStep(candidateval) === 'INTERVIEW'}">
            <div class="step-circle"></div>
            <span class="step-label">Interview</span>
          </div>
          <div class="step-connector" [ngClass]="{'completed': isStepCompleted('SELECTED', candidateval)}"></div>
          <div class="step-item" [ngClass]="{'completed': isStepCompleted('SELECTED', candidateval), 'active': getCurrentStep(candidateval) === 'SELECTED'}">
            <div class="step-circle"></div>
            <span class="step-label">Selected</span>
          </div>
          <div class="step-connector" [ngClass]="{'completed': isStepCompleted('OFFERED', candidateval)}"></div>
          <div class="step-item" [ngClass]="{'completed': isStepCompleted('OFFERED', candidateval), 'active': getCurrentStep(candidateval) === 'OFFERED'}">
            <div class="step-circle"></div>
            <span class="step-label">Offers</span>
          </div>
          <div class="step-connector" [ngClass]="{'completed': isStepCompleted('ONBOARDED', candidateval)}"></div>
          <div class="step-item" [ngClass]="{'completed': isStepCompleted('ONBOARDED', candidateval), 'active': getCurrentStep(candidateval) === 'ONBOARDED'}">
            <div class="step-circle"></div>
            <span class="step-label">Onboards</span>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</ng-container>

<!-- ============================================================ -->
<!-- ROW DESIGN VIEW - Single Candidate Row Layout -->
<!-- ============================================================ -->
<ng-container *ngIf="viewSize == 'row-design'">
  <!-- Single Row for One Candidate -->
  <div class="row-design-row" [ngClass]="{
    'disabled': !candidateval.availability || candidateval.status != 'ACTIVE' || (jobStatus !== '' && jobStatus !== 'ACTIVE'),
    'featured-background': candidateval?.isFeatured === true}">

    <!-- Rank Column -->
    <div class="row-design-cell rank-col">
      <div class="row-design-rank-circle">{{candidateval.rank || 1}}</div>
    </div>

    <!-- Candidate Column -->
    <div id="candidate_card_row_profile" class="row-design-cell candidate-col"  (click)="openCandidateInSlidePanel(candidateval)">
      <div class="row-design-candidate-info">
        <div class="row-design-candidate-avatar" *ngIf="candidateval?.user?.photo != undefined">
          <img [src]="url + candidateval.user.photo" alt="avatar" (error)="$event.target.style.display='none'">
        </div>
        <div class="row-design-candidate-avatar" *ngIf="candidateval?.user?.photo == undefined">
          <div class="row-design-avatar-initials" [style.background-color]="getColor(candidateval?.user?.fullname)"
            [style.color]="getFullNameTextColor(candidateval?.user?.fullname)">
            {{getInitials(candidateval?.user?.fullname)}}
          </div>
        </div>
        <div class="row-design-candidate-details">
          <div class="row-design-candidate-name">{{candidateval?.firstName}} {{candidateval?.lastName}}</div>
          <div class="row-design-candidate-title" *ngIf="userTypeMap[candidateval?.user?.userType]">
            {{ userTypeMap[candidateval?.user?.userType] }}
          </div>
          <div class="row-design-candidate-experience">{{candidateval?.totalExperience || 0}}+ Years</div>
          <div *ngIf="candidateval?.latest && candidateval.latest == true" class="row-design-latest-badge">New</div>
          <div [ngStyle]="getStyle(candidateval?.status)" class="br-pd-1" 
            *ngIf="shouldShowStatusText()" style="padding:4px 5px; width:fit-content;">
            {{ getStatusText() }}
          </div>
        </div>
      </div>
    </div>

    <!-- Title & Location Column -->
    <div class="row-design-cell location-col">
      <div class="row-design-location-info">
        <div class="row-design-location-text">
          {{candidateval?.jobTitle}}
        </div>
        <div class="row-design-location-text">
          {{candidateval?.city}}<span *ngIf="candidateval?.city && candidateval?.state">, </span>{{candidateval?.state}}
        </div>
        <div class="row-design-availability-text">Candidate ID: {{candidateval?.candidateId}}</div>
        <div class="row-design-availability-text">Available: {{candidateval?.availableIn || '2 weeks'}}</div>
        <div class="row-design-badge-row">
          <div class="row-design-work-mode-badge" *ngIf="candidateval?.workMode">
            {{candidateval?.workMode}}
          </div>
          <div class="row-design-status-badge" *ngIf="candidateval?.status"
            [ngStyle]="getStyle(candidateval?.status)">
            {{ convertSmallCase(candidateval?.status) }}
          </div>
          <div class="urgent-hire-badge-compact" *ngIf="getActiveUrgencyDays(candidateval)">
            <ng-icon name="tablerFlame" style="font-size: 9px;"></ng-icon> Hot
          </div>
        </div>
      </div>
    </div>

    <!-- Skills Column -->
    <div class="row-design-cell skills-col">
      <div class="row-design-skills-container" *ngIf="!candidateval.showAllSkills">
        <span class="row-design-skill-tag row-design-primary-skill text-primary-2"
        *ngFor="let skill of getAllSkills(candidateval).slice(0, 2)"
        [ngStyle]="{ 'border-radius': getBorderRadius(skill) }">
          {{skill}}
        </span>
        <span id="candidate_card_row_expand_skills_button" class="row-design-skill-count text-primary-2"
          *ngIf="getAllSkills(candidateval).length > 2" (click)="toggleSkills(candidateval)">
          +{{ getAllSkills(candidateval).length - 2 }}
        </span>
      </div>
      <div class="row-design-skills-container row-design-expanded" *ngIf="candidateval.showAllSkills">
        <span class="row-design-skill-tag row-design-primary-skill text-primary-2"
          *ngFor="let skill of getAllSkills(candidateval)"
          [ngStyle]="{ 'border-radius': getBorderRadius(skill) }">
          {{skill}}
        </span>
        <!-- <span class="row-design-skill-tag row-design-secondary-skill text-primary-2"
          *ngFor="let skill of candidateval?.secondarySkills">
          {{skill}}
        </span> -->
        <span id="candidate_card_row_collapse_skills_button" class="row-design-skill-collapse"
          (click)="toggleSkills(candidateval)">
          Show less
        </span>
      </div>
    </div>

    <!-- Match Column -->
    <div class="row-design-cell match-col">
      <div class="row-design-match-score">
        <span class="row-design-match-percent text-primary-2" *ngIf="pageName == 'job-applicants' || pageName == 'candidate-applied'">
          {{ candidateval.matchingScore != null ? (candidateval.matchingScore % 1 === 0 ? candidateval.matchingScore +
          '%' : (candidateval.matchingScore | number:'1.2-2') + '%') : '-' }}
        </span>
        <span class="row-design-match-percent text-primary-2" *ngIf="pageName != 'job-applicants' && pageName != 'candidate-applied'">
          {{ candidateval.score != null ? candidateval.score + '%' : '-' }}
        </span>
      </div>
      <img *ngIf="candidateval.matchingScore != null && (pageName == 'job-applicants'  || pageName == 'candidate-applied')"
        src="../../../../assets/images/details icon.png" alt=""
        style="height: 33px; width: 33px; cursor:pointer !important;" (click)="openPercentageDetails(candidateval)">

      <img *ngIf="candidateval.score != null && (pageName != 'job-applicants'  && pageName != 'candidate-applied')"
        src="../../../../assets/images/details icon.png" alt=""
        style="height: 33px; width: 33px; cursor:pointer !important;" (click)="openPercentageDetails(candidateval)">
    </div>

    <!-- Engagement Column -->
    <div class="row-design-cell engagement-col">
      <div class="row-design-engagement-stats">
        <div *ngIf="candidateval.createdBy == userId">
          <div [title]="candidateval?.viewedByCount + ' Views'" class="row-design-stat-item" *ngIf="candidateval.viewedByCount > 0" (click)="goTo(candidateval, 'views')">
            <ng-icon name="tablerEye"></ng-icon> {{ candidateval?.viewedByCount | compactCount }} Views
          </div>
          <div class="row-design-stat-item" *ngIf="candidateval.viewedByCount == 0" (click)="goTo(candidateval, 'Noviews')">
            <ng-icon name="tablerEye"></ng-icon> 0 Views
          </div>
        </div>
        <div *ngIf="candidateval.createdBy != userId">
          <div [title]="candidateval?.viewedByCount + ' Views'" class="row-design-stat-item" *ngIf="candidateval.viewedByCount > 0" >
            <ng-icon name="tablerEye"></ng-icon> {{ candidateval?.viewedByCount | compactCount }} Views
          </div>
          <div class="row-design-stat-item" *ngIf="candidateval.viewedByCount == 0">
            <ng-icon name="tablerEye"></ng-icon> 0 Views
          </div>
        </div>
        <!-- <div class="row-design-stat-item">
          <ng-icon name="tablerEye"></ng-icon> {{candidateval?.viewedByCount || 0}} Views
        </div> -->

        <!-- Like/Unlike Heart Icon -->
        <div id="candidate_card_row_like_button" class="row-design-stat-item" *ngIf="candidateval?.isLiked != null"
          (click)="like(candidateval)">
          <ng-icon name="tablerHeart" class="pointer md-interaction-element" [ngClass]="candidateval.isLiked ? 'bg-heart liked' : 'icon-prime-color'"></ng-icon>

          <!-- Likes Count and Action -->
          <div id="candidate_card_row_likes_button" class="md-interaction-element"
            (click)="goTo(candidateval, 'Clike-like')"
            *ngIf="candidateval?.isLiked != null && candidateval.createdBy == userId">
            <span [title]="candidateval.likesCount + ' Likes'" class="blue-color">{{ candidateval.likesCount | compactCount }}</span>
            <span> Like<span *ngIf="candidateval.likesCount > 1">s</span></span>
          </div>

          <!-- Likes Count for Non-Creators -->
          <div class="md-interaction-element" style="cursor: context-menu;"
            *ngIf="candidateval?.isLiked != null && candidateval.createdBy != userId">
            <span [title]="candidateval.likesCount + ' Likes'" class="blue-color">{{ candidateval.likesCount | compactCount }}</span>
            <span> Like<span *ngIf="candidateval.likesCount > 1">s</span></span>
          </div>
        </div>
      </div>
    </div>

    <!-- Stage Column -->
    <div class="row-design-cell stage-col" *ngIf="(pageName == 'job-applicants'  || pageName == 'candidate-applied') && showStatus">
      <div class="row-design-stage-dropdown" dropdown>
        <!-- <button class="row-design-stage-btn" dropdownToggle
                [style.background-color]="getStageStyle(candidateval?.currentStatus || 'APPLIED')?.background"
                [style.color]="getStageStyle(candidateval?.currentStatus || 'APPLIED')?.color"
                [style.border]="'1px solid ' + (getStageStyle(candidateval?.currentStatus || 'APPLIED')?.background || '#E5E7EB')">
          {{getStageLabel(candidateval?.currentStatus || 'APPLIED')}}

          <ng-icon name="tablerChevronDown" *ngIf="!isExcludedStatus(candidateval?.currentStatus) && jobDetails?.jobPostedBy==userId"></ng-icon>

        </button> -->

        <button id="candidate_card_medium_status_dropdown_button"  data-toggle="dropdown" dropdownToggle
          (click)="triggerChange(candidateval.candidateId)" class="row-design-stage-btn"
          aria-expanded="true" [ngStyle]="getStyle(candidateval?.currentStatus)">
          <ng-container> {{ getFilterValue(candidateval.currentStatus) |titlecase}} </ng-container>
          <ng-container *ngIf=" pageName === 'job-applicants' && !isExcludedStatus(candidateval?.currentStatus) && candidateval?.canUpdateStatus !== false">
            <ng-icon name="tablerChevronDown"></ng-icon>
          </ng-container>
        </button>

        <ng-container *ngIf="!isExcludedStatus(candidateval?.currentStatus) && candidateval?.canUpdateStatus !== false">
          <ul *dropdownMenu class="dropdown-menu row-design-stage-menu">
            <li role="menuitem" *ngFor="let statusData of filterApplicant(candidateval?.currentStatus, candidateval?.nextAllowedStatuses)"
              [class.gs-status-locked]="isStatusLocked(statusData)"
              [attr.aria-disabled]="isStatusLocked(statusData) ? true : null"
              [attr.title]="isStatusLocked(statusData) ? 'Managed from Contract Manager' : null"
              (click)="isStatusLocked(statusData) ? $event.stopPropagation() : validateNegativeStatus(statusData, candidateval, interviewPayrateTemplate)" id="{{statusData?.item}}">
              <a id="{{statusData?.item}}"><ng-icon name="tablerCircle"></ng-icon>&nbsp;
                {{statusData?.item}}
              </a>
            </li>
          </ul>
        </ng-container>
      </div>
    </div>

    <!-- Quick Actions Column -->
    <div class="row-design-cell actions-col">
      <div class="row-design-action-buttons">
        <button id="candidate_card_row_view_profile" class="row-design-action-btn" title="View Profile"
          (click)="openCandidateInSlidePanel(candidateval)">
          <ng-icon name="tablerEye"></ng-icon>
        </button>

        <div *ngIf="candidateval?.resumes?.length > 0">
          <ng-container *ngFor="let item of candidateval?.resumes">
            <button id="candidate_card_row_download_resume" class="row-design-action-btn" title="Download Resume"
              *ngIf="item?.isDefault" (click)="downloadResume(candidateval,userId,item.fileId)">
              <ng-icon name="tablerDownload"></ng-icon>
            </button>
          </ng-container>
        </div>

        <!-- Invite to Apply - only for talent-pool and suggested-candidates pages -->
        <button id="candidate_card_row_invite" class="row-design-action-btn" title="Invite to apply"
          *ngIf="(pageName === 'talent-pool' || pageName === 'suggested-candidates') && (userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION' || userType == 'BENCH_RECRUITER')"
          (click)="invite(candidateval, connectionTemplate,jobsupplytemplate)">
          <ng-icon name="tablerMail"></ng-icon>
        </button>

        <button id="candidate_card_row_send_message1" *ngIf="candidateval.chatHistoryCount>0"
          class="row-design-action-btn" (click)="openMessagecheckInteraction(candidateval, connectionTemplate)"
          title="{{candidateval.nonSeenMessageCount}} Messages">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          <span class="blue-color">{{candidateval.nonSeenMessageCount}} </span>

        </button>
        <button id="candidate_card_row_send_message2"
          *ngIf="candidateval.createdBy!=userId && candidateval.chatHistoryCount == 0"
          (click)="openMessagecheckInteraction(candidateval, connectionTemplate)" class="row-design-action-btn" title="No Messages">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>

        </button>
        <button *ngIf="candidateval.createdBy==userId && candidateval.chatHistoryCount == 0"
          class="row-design-action-btn" title="{{candidateval.nonSeenMessageCount}} Messages">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>

        </button>

        <button *ngIf="['OFFER-ACCEPTED','PRE-ONBOARDED','ONBOARDED'].includes(candidateval?.currentStatus)"
          id="candidate_card_row_documents_button" class="row-design-action-btn" title="Candidate Document"
          (click)="openDocuments()">
          <ng-icon name="tablerFileText"></ng-icon>
          <span *ngIf="candidateval.totalMandatoryDocuments > 0"
            class="row-design-doc-count-badge">{{candidateval.totalMandatoryDocuments}}</span>
        </button>

        <button id="candidate_card_row_payrate_button" class="row-design-action-btn payratebutton" title="Pay Rate"
        *ngIf="appliedJobDetails?.jobPostedBy!=userId && candidateval.createdBy!=userId" [disabled]="!['OFFERED','OFFER-ACCEPTED','PRE-ONBOARDED'].includes(candidateval?.currentStatus)"
          (click)="openPayRate(candidateval, interviewPayrateTemplate)">
          <ng-icon name="tablerCash" class="mr-1"></ng-icon>
          Pay Rate
        </button>
      </div>
    </div>

    <!-- Timeline Progress Bar -->
    <!-- <div class="row-design-timeline-progress" *ngIf="showTimeline && candidateval?.timelineStages && candidateval.timelineStages.length > 0">
      <div class="row-design-timeline-track">
        <ng-container *ngFor="let stage of candidateval.timelineStages; let i = index; let last = last">
          <div class="row-design-timeline-step"
               [class.completed]="stage.completed"
               [class.active]="stage.active"
               [class.negative]="stage.isNegative"
               [class.terminal]="stage.isTerminal"
               [class.implied]="stage.isImplied"
               [class.future]="stage.notion === 'future'"
               [title]="stage.isImplied && stage.date ? (stage.label + ' - Skipped (reached higher stage on ' + (stage.date | timezoneDate:'dd MMM yyyy') + ')') : (stage.isImplied ? (stage.label + ' - Skipped (implied completion)') : (stage.completed && stage.date ? (stage.label + ' - Completed on ' + (stage.date | timezoneDate:'dd MMM yyyy')) : (stage.label + (stage.activityType ? ' (' + stage.activityType + ')' : ''))))">
            <div class="row-design-step-dot">
              <ng-icon name="tablerCheck" *ngIf="stage.completed && !stage.isTerminal"></ng-icon>
            </div>
            <span class="row-design-step-label">
              {{stage.label}}
            </span>
            <span class="row-design-step-date" *ngIf="stage.date">
              {{stage.date | timezoneDate:'dd MMM yyyy'}}
            </span>
          </div>
          <div class="row-design-timeline-connector"
               *ngIf="!last"
               [class.completed]="candidateval?.timelineStages[i + 1]?.completed && !stage.isTerminal"
               [class.negative]="stage.isNegative"></div>
        </ng-container>
      </div>
    </div> -->

    <!-- Timeline Progress Bar with Stage-Based Logic -->
    <!-- 🔄 Loading shimmer timeline -->
    <div class="row-design-timeline-progress loading" *ngIf="isTimelineLoading; else timelineContent">
      <div class="row-design-timeline-track">
        <ng-container *ngFor="let stage of defaultTimelineSkeleton; let i = index; let last = last">
          <div class="row-design-timeline-step loading-step" [title]="stage.label">
            <div class="row-design-step-dot loading-dot" [style.--delay]="i">
            </div>
            <span class="row-design-step-label ">
              {{stage.label}}
            </span>
            <span class="row-design-step-date ">
              &nbsp;
            </span>
          </div>
          <div class="row-design-timeline-connector loading-connector" *ngIf="!last"></div>
        </ng-container>
      </div>
    </div>

    <!-- ✅ Actual timeline -->
    <ng-template #timelineContent>
      <div class="row-design-timeline-progress" *ngIf="showTimeline && timelineDataGrouped && timelineDataGrouped.length > 0">
        <div class="row-design-timeline-track">
          <ng-container *ngFor="let stage of timelineDataGrouped; let i = index; let last = last">
            <div class="row-design-timeline-step"
                [class.completed]="stage.completed"
                [class.negative]="stage.negative"
                [class.future]="stage.future"
                [title]="stage.isImplied ? '( skipped ) ' + stage.label : stage.label">
              <div class="row-design-step-dot">
                <ng-icon name="tablerCheck" *ngIf="stage.completed && !stage.negative"></ng-icon>
                <ng-icon name="tablerX" *ngIf="stage.negative"></ng-icon>
              </div>
              <span class="row-design-step-label">
                {{stage.label}}
              </span>
              <span class="row-design-step-date" *ngIf="stage.date">
                {{stage.date | timezoneDate:'dd MMM yyyy'}}
              </span>
            </div>
            <div class="row-design-timeline-connector"
                *ngIf="!last"
                [class.completed]="stage.completed && timelineDataGrouped[i + 1]?.completed">
            </div>
          </ng-container>
        </div>
      </div>
    </ng-template>

  </div>
</ng-container>

<!-- ============================================================ -->
<!-- CUSTOMER ROW DESIGN - For Customer Business Candidate List -->
<!-- Same as row-design but WITHOUT Rank and Match/Score columns -->
<!-- ============================================================ -->
<ng-container *ngIf="viewSize == 'customer-row-design'">
  <div class="crd-row" [ngClass]="{
    'crd-disabled': (!candidateval.availability || candidateval.status != 'ACTIVE') && !showCheckBox,
    'crd-featured': candidateval?.isFeatured === true,
    'crd-selection-mode': showCheckBox}">

    <!-- Checkbox Column (for selection mode) -->
    <div class="crd-cell crd-checkbox-col" *ngIf="showCheckBox">
      <label class="checkbox-label font-normal">
        <input type="checkbox" (click)="selectCheckbox1($event, candidateval)"
          [(ngModel)]="candidateval.isSelected"
          (ngModelChange)="onNgModelChange($event, candidateval?.candidateId)" name="list_name" />
        <span class="checkmark"></span>
      </label>
    </div>

    <!-- Owner Column -->
    <div class="crd-cell crd-owner-col">
      <div class="crd-owner-info">
        <div class="crd-owner-avatar" *ngIf="candidateval?.user?.photo && candidateval?.user?.photo != 'null' && candidateval?.user?.photo != ''">
          <img [src]="candidateval?.user?.photo?.startsWith('http') ? candidateval?.user?.photo : url + candidateval?.user?.photo" alt="owner" (error)="$event.target.style.display='none'">
        </div>
        <div class="crd-owner-avatar" *ngIf="!candidateval?.user?.photo || candidateval?.user?.photo == 'null' || candidateval?.user?.photo == ''">
          <div class="crd-owner-initials"
            [style.background-color]="getColor(candidateval?.user?.fullname)"
            [style.color]="getFullNameTextColor(candidateval?.user?.fullname)"
             style="font-family: Arial, sans-serif;font-weight: 550; font-style: normal;"
            
            >
            {{getInitials(candidateval?.user?.fullname)}}
          </div>
        </div>
        <div class="crd-owner-details">
          <div class="crd-owner-name" title="{{candidateval?.user?.fullname}}">{{candidateval?.user?.fullname}}</div>
          <!-- Owner's role (Recruiter / Bench Recruiter / Manager / …). Sits
               under the owner name because `user.userType` describes the owner,
               not the candidate — it previously rendered under the candidate
               name as `.crd-candidate-title`, which read as the candidate's own
               title. Mirrors `.jc-v3-c-rec-role` in the V3 candidate row. -->
          <div class="crd-owner-role" *ngIf="userTypeMap[candidateval?.user?.userType]"
               [title]="userTypeMap[candidateval?.user?.userType]">
            {{ userTypeMap[candidateval?.user?.userType] }}
          </div>
        </div>
      </div>
    </div>

    <!-- Candidate Column -->
    <div class="crd-cell crd-candidate-col" (click)="openCandidateInSlidePanel(candidateval)">
      <div class="crd-candidate-info">
        <div class="crd-candidate-avatar" *ngIf="candidateval?.photo && candidateval?.photo != 'null' && candidateval?.photo != ''">
          <img [src]="candidateval?.photo?.startsWith('http') ? candidateval?.photo : url + candidateval?.photo" alt="avatar" (error)="$event.target.style.display='none'">
        </div>
        <div class="crd-candidate-avatar" *ngIf="!candidateval?.photo || candidateval?.photo == 'null' || candidateval?.photo == ''">
          <div class="crd-avatar-initials" [style.background-color]="getColor(candidateval?.firstName + ' ' + candidateval?.lastName)"
            [style.color]="getFullNameTextColor(candidateval?.firstName + ' ' + candidateval?.lastName)"
            style="font-family: Arial, sans-serif; font-style: normal;">
            {{getInitials(candidateval?.firstName + ' ' + candidateval?.lastName)}}
          </div>
        </div>
        <div class="crd-candidate-details">
          <div class="crd-candidate-name">{{candidateval?.firstName}} {{candidateval?.lastName}}</div>
          <div class="crd-candidate-experience">{{candidateval?.totalExperience || 0}}+ Years</div>
          <!-- Engagement type (Corp to Corp / W2 / 1099 / …). Already a
               display-ready string from the backend — same raw render as the
               candidate profile summary
               (candidate-profile-summary.component.html:41-43). Guarded so the
               line collapses rather than printing an empty row when the list
               payload omits it. -->
          <div class="crd-candidate-engagement" *ngIf="candidateval?.engagementType"
               [title]="candidateval?.engagementType">
            {{ candidateval?.engagementType }}
          </div>
          <div *ngIf="candidateval?.latest && candidateval.latest == true" class="crd-latest-badge">New</div>
        </div>
      </div>
    </div>

    <!-- Title & Location Column -->
    <div class="crd-cell crd-location-col">
      <div class="crd-location-info">
        <div class="crd-location-text crd-job-title" style="cursor: pointer;" (click)="openCandidateInSlidePanel(candidateval)">{{candidateval?.jobTitle}}</div>
        <div class="crd-location-text">
          {{candidateval?.city}}<span *ngIf="candidateval?.city && candidateval?.state">, </span>{{candidateval?.state}}
        </div>
        <div class="crd-availability-text">Candidate ID: {{candidateval?.candidateId}}</div>
        <div class="crd-availability-text">Available: {{candidateval?.availableIn || '2 weeks'}}</div>
        <div class="crd-badge-row">
          <div class="crd-work-mode-badge" *ngIf="candidateval?.workMode">{{candidateval?.workMode}}</div>
          <div class="crd-status-badge" *ngIf="candidateval?.status"
            [ngStyle]="getStyle(candidateval?.status)">
            {{ getCandidateStatusLabel(candidateval?.status) }}
          </div>
          <div class="urgent-hire-badge-compact" *ngIf="getActiveUrgencyDays(candidateval)">
            <ng-icon name="tablerFlame" style="font-size: 9px;"></ng-icon> Hot
          </div>
        </div>
      </div>
    </div>

    <!-- Skills Column -->
    <div class="crd-cell crd-skills-col">
      <ng-container *ngIf="getAllSkills(candidateval).length > 0; else noSkillsHyphenC">
        <div class="crd-skills-container" *ngIf="!candidateval.showAllSkills">
          <span class="crd-skill-tag crd-primary-skill"
            *ngFor="let skill of getAllSkills(candidateval).slice(0, 2)"
            [ngStyle]="{ 'border-radius': getBorderRadius(skill) }"
            [title]="skill">
            {{skill}}
          </span>
          <span class="crd-skill-count"
            *ngIf="getAllSkills(candidateval).length > 2" (click)="toggleSkills(candidateval)">
            +{{ getAllSkills(candidateval).length - 2 }}
          </span>
        </div>
        <div class="crd-skills-container crd-expanded" *ngIf="candidateval.showAllSkills">
          <span class="crd-skill-tag crd-primary-skill"
            *ngFor="let skill of getAllSkills(candidateval)"
            [ngStyle]="{ 'border-radius': getBorderRadius(skill) }"
            [title]="skill">
            {{skill}}
          </span>
          <span class="crd-skill-collapse" (click)="toggleSkills(candidateval)">Show less</span>
        </div>
      </ng-container>
      <!-- No skills → show a hyphen instead of empty space. -->
      <ng-template #noSkillsHyphenC>
        <span class="crd-empty-dash">-</span>
      </ng-template>
    </div>

    <!-- Engagement Column -->
    <div class="crd-cell crd-engagement-col">
      <div class="crd-engagement-stats">
        <div *ngIf="candidateval.createdBy == userId">
          <div class="crd-stat-item" *ngIf="candidateval.viewedByCount > 0" (click)="goTo(candidateval, 'views')">
            <ng-icon name="tablerEye" class="icon-prime-color"></ng-icon> <span [title]="candidateval?.viewedByCount + ' Views'" class="blue-color">{{ candidateval?.viewedByCount | compactCount }}</span> Views
          </div>
          <div class="crd-stat-item" *ngIf="candidateval.viewedByCount == 0" (click)="goTo(candidateval, 'Noviews')">
            <ng-icon name="tablerEye" class="icon-prime-color"></ng-icon> <span class="blue-color">0</span> Views
          </div>
        </div>
        <div *ngIf="candidateval.createdBy != userId">
          <div class="crd-stat-item" *ngIf="candidateval.viewedByCount > 0">
            <ng-icon name="tablerEye" class="icon-prime-color"></ng-icon> <span [title]="candidateval?.viewedByCount + ' Views'" class="blue-color">{{ candidateval?.viewedByCount | compactCount }}</span> Views
          </div>
          <div class="crd-stat-item" *ngIf="candidateval.viewedByCount == 0">
            <ng-icon name="tablerEye" class="icon-prime-color"></ng-icon> <span class="blue-color">0</span> Views
          </div>
        </div>

        <!-- Like/Unlike Heart Icon -->
        <div class="crd-stat-item" *ngIf="candidateval?.isLiked != null" (click)="like(candidateval)">
          <ng-icon name="tablerHeart" class="pointer md-interaction-element" [ngClass]="candidateval.isLiked ? 'bg-heart liked' : 'icon-prime-color'"></ng-icon>
          <div class="md-interaction-element"
            (click)="goTo(candidateval, 'Clike-like')"
            *ngIf="candidateval?.isLiked != null && candidateval.createdBy == userId">
            <span [title]="candidateval.likesCount + ' Likes'" class="blue-color">{{ candidateval.likesCount | compactCount }}</span>
            <span> Like<span *ngIf="candidateval.likesCount > 1">s</span></span>
          </div>
          <div class="md-interaction-element" style="cursor: context-menu;"
            *ngIf="candidateval?.isLiked != null && candidateval.createdBy != userId">
            <span [title]="candidateval.likesCount + ' Likes'" class="blue-color">{{ candidateval.likesCount | compactCount }}</span>
            <span> Like<span *ngIf="candidateval.likesCount > 1">s</span></span>
          </div>
        </div>
      </div>
    </div>

    <!-- Quick Actions Column -->
    <div class="crd-cell crd-actions-col">
      <div class="crd-action-buttons">
        <button class="crd-action-btn" title="View Profile" (click)="openCandidateInSlidePanel(candidateval)">
          <ng-icon name="tablerEye"></ng-icon>
        </button>

        <div *ngIf="candidateval?.resumes?.length > 0">
          <ng-container *ngFor="let item of candidateval?.resumes">
            <button class="crd-action-btn" title="Download Resume"
              *ngIf="item?.isDefault" (click)="downloadResume(candidateval,userId,item.fileId)">
              <ng-icon name="tablerDownload"></ng-icon>
            </button>
          </ng-container>
        </div>

        <button class="crd-action-btn" title="Invite to apply"
          *ngIf="candidateval.createdBy!=userId && (userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')"
          (click)="invite(candidateval, connectionTemplate,jobsupplytemplate)">
          <ng-icon name="tablerMail"></ng-icon>
        </button>

        <button *ngIf="candidateval.chatHistoryCount>0"
          class="crd-action-btn" (click)="openMessagecheckInteraction(candidateval, connectionTemplate)"
          title="{{candidateval.nonSeenMessageCount > 0 ? candidateval.nonSeenMessageCount + ' Messages' : 'No Messages'}}">
          <span class="chat-icon-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          <span class="noti-badge noti-chat-ico" *ngIf="candidateval.nonSeenMessageCount>0">{{candidateval.nonSeenMessageCount}}</span>
          </span>
        </button>
        <button *ngIf="candidateval.createdBy!=userId && candidateval.chatHistoryCount == 0"
          (click)="openMessagecheckInteraction(candidateval, connectionTemplate)" class="crd-action-btn" title="No Messages">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
        </button>
        <button *ngIf="candidateval.createdBy==userId && candidateval.chatHistoryCount == 0"
          class="crd-action-btn" title="No Messages">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
        </button>

        <button class="crd-action-btn" title="More Options" dropdown>
          <ng-icon name="tablerDots" dropdownToggle></ng-icon>
          <ul *dropdownMenu class="dropdown-menu">
            <li><a (click)="shareProfile(candidateval)">Share Profile</a></li>
          </ul>
        </button>
      </div>
    </div>

  </div>
</ng-container>

<!-- ============================================================ -->
<!-- CONTRACT ROW VIEW - For Contract Module Usage -->
<!-- ============================================================ -->
<ng-container *ngIf="viewSize == 'contract-row'">
  <div class="ctr-row" [ngClass]="{
    'ctr-disabled': !candidateval.availability || candidateval.status != 'ACTIVE',
    'ctr-featured': candidateval?.isFeatured === true,
    'ctr-selection-mode': showCheckBox}">

    <!-- Checkbox Overlay (visible only in selection mode) -->
    <div class="ctr-checkbox-overlay" *ngIf="showCheckBox">
      <label class="checkbox-label font-normal">
        <input type="checkbox" (click)="selectCheckbox1($event, candidateval)"
          [(ngModel)]="candidateval.isSelected"
          (ngModelChange)="onNgModelChange($event, candidateval?.candidateId)" name="list_name" />
        <span class="checkmark"></span>
      </label>
    </div>

    <!-- Content Wrapper - Contains all columns except timeline -->
    <div class="ctr-content">
      <!-- Owner Column - Candidate Creator Info -->
      <div class="ctr-cell ctr-owner-col">
        <div class="ctr-owner-info">
          <div class="ctr-owner-avatar" *ngIf="candidateval?.user?.photo && candidateval?.user?.photo != 'null' && candidateval?.user?.photo != ''">
            <img [src]="url + candidateval?.user?.photo" alt="owner" (error)="$event.target.style.display='none'">
          </div>
          <div class="ctr-owner-avatar" *ngIf="!candidateval?.user?.photo || candidateval?.user?.photo == 'null' || candidateval?.user?.photo == ''">
            <div class="ctr-owner-initials"
              [style.background-color]="getColor(candidateval?.user?.fullname)"
              [style.color]="getFullNameTextColor(candidateval?.user?.fullname)">
              {{getInitials(candidateval?.user?.fullname)}}
            </div>
          </div>
          <div class="ctr-owner-details">
            <div class="ctr-owner-name" title="{{candidateval?.user?.fullname}}">{{candidateval?.user?.fullname}}</div>
            <div class="ctr-owner-org" *ngIf="hasCurrentOrganization">
              <ng-container *ngFor="let work of candidateval?.user?.workExperience">
                <span *ngIf="work?.currentOrganization" title="{{work?.organisationName}}">
                  {{work?.organisationName}}
                </span>
              </ng-container>
            </div>
            <div class="ctr-owner-timestamp" *ngIf="candidateval?.updatedOn">
              {{candidateval?.updatedOn | timezoneDate:'MM/dd/yyyy'}}
            </div>
          </div>
        </div>
      </div>

      <!-- Candidate Column -->
      <div id="ctr_candidate_profile" class="ctr-cell ctr-candidate-col" (click)="openCandidateInSlidePanel(candidateval)">
        <div class="ctr-candidate-info">
          <div class="ctr-candidate-avatar" *ngIf="candidateval?.user?.photo && candidateval?.user?.photo != 'null' && candidateval?.user?.photo != ''">
            <img [src]="url + candidateval.user.photo" alt="avatar" (error)="$event.target.style.display='none'">
          </div>
          <div class="ctr-candidate-avatar" *ngIf="!candidateval?.user?.photo || candidateval?.user?.photo == 'null' || candidateval?.user?.photo == ''">
            <div class="ctr-avatar-initials" [style.background-color]="getColor(candidateval?.user?.fullname)"
              [style.color]="getFullNameTextColor(candidateval?.user?.fullname)">
              {{getInitials(candidateval?.user?.fullname)}}
            </div>
          </div>
          <div class="ctr-candidate-details">
            <div class="ctr-candidate-name">{{candidateval?.firstName}} {{candidateval?.lastName}}</div>
            <div class="ctr-candidate-experience">{{candidateval?.totalExperience || 0}}+ Years</div>
            <div *ngIf="candidateval?.latest && candidateval.latest == true" class="ctr-latest-badge">New</div>
            <div [ngStyle]="getStyle(candidateval?.status)" class="ctr-status-badge"
              *ngIf="shouldShowStatusText()">
              {{ getStatusText() }}
            </div>
          </div>
        </div>
      </div>

      <!-- Title & Location Column -->
      <div class="ctr-cell ctr-location-col">
        <div class="ctr-location-info">
          <div class="ctr-location-text">{{candidateval?.jobTitle}}</div>
          <div class="ctr-location-text">
            {{candidateval?.city}}<span *ngIf="candidateval?.city && candidateval?.state">, </span>{{candidateval?.state}}
          </div>
          <div class="ctr-availability-text">Candidate ID: {{candidateval?.candidateId}}</div>
          <div class="ctr-availability-text">Available: {{candidateval?.availableIn || '2 weeks'}}</div>
          <div class="ctr-work-mode-badge" *ngIf="candidateval?.workMode">{{candidateval?.workMode}}</div>
        </div>
      </div>

      <!-- Skills Column -->
      <div class="ctr-cell ctr-skills-col">
        <div class="ctr-skills-container" *ngIf="!candidateval.showAllSkills">
          <span class="ctr-skill-tag ctr-primary-skill text-primary-2"
            *ngFor="let skill of getAllSkills(candidateval).slice(0, 2)"
            [ngStyle]="{ 'border-radius': getBorderRadius(skill) }">
            {{skill}}
          </span>
          <span id="ctr_expand_skills_button" class="ctr-skill-count text-primary-2"
            *ngIf="getAllSkills(candidateval).length > 2" (click)="toggleSkills(candidateval)">
            +{{ getAllSkills(candidateval).length - 2 }}
          </span>
        </div>
        <div class="ctr-skills-container ctr-expanded" *ngIf="candidateval.showAllSkills">
          <span class="ctr-skill-tag ctr-primary-skill text-primary-2"
            *ngFor="let skill of getAllSkills(candidateval)"
            [ngStyle]="{ 'border-radius': getBorderRadius(skill) }">
            {{skill}}
          </span>
          <span id="ctr_collapse_skills_button" class="ctr-skill-collapse" (click)="toggleSkills(candidateval)">
            Show less
          </span>
        </div>
      </div>

      <!-- Match Column -->
      <div class="ctr-cell ctr-match-col" *ngIf="!aiMatchHide">
        <div class="ctr-match-score">
          <span class="ctr-match-percent text-primary-2" *ngIf="pageName == 'job-applicants' || pageName == 'candidate-applied'">
            {{ candidateval.matchingScore != null ? (candidateval.matchingScore % 1 === 0 ? candidateval.matchingScore +
            '%' : (candidateval.matchingScore | number:'1.2-2') + '%') : '-' }}
          </span>
          <span class="ctr-match-percent text-primary-2" *ngIf="pageName != 'job-applicants' && pageName != 'candidate-applied'">
            {{ candidateval.score != null && candidateval.score != '0' ? candidateval.score + '%' : '-' }}
          </span>
        </div>
        <img *ngIf="candidateval.matchingScore != null && (pageName == 'job-applicants' || pageName == 'candidate-applied')"
          src="../../../../assets/images/details icon.png" alt=""
          style="height: 33px; width: 33px; cursor:pointer !important;" (click)="openPercentageDetails(candidateval)">
        <img *ngIf="candidateval.score != null && (pageName != 'job-applicants' && pageName != 'candidate-applied')"
          src="../../../../assets/images/details icon.png" alt=""
          style="height: 33px; width: 33px; cursor:pointer !important;" (click)="openPercentageDetails(candidateval)">
      </div>

      <!-- Engagement Column -->
      <div class="ctr-cell ctr-engagement-col" [ngClass]="{'ctr-disabled-element': jobStatus !== '' && jobStatus !== 'ACTIVE'}">
        <div class="ctr-engagement-stats">
          <div *ngIf="candidateval.createdBy == userId">
            <div [title]="candidateval?.viewedByCount + ' Views'" class="ctr-stat-item" *ngIf="candidateval.viewedByCount > 0" (click)="goTo(candidateval, 'views')">
              <ng-icon name="tablerEye"></ng-icon> {{ candidateval?.viewedByCount | compactCount }} Views
            </div>
            <div class="ctr-stat-item" *ngIf="candidateval.viewedByCount == 0" (click)="goTo(candidateval, 'Noviews')">
              <ng-icon name="tablerEye"></ng-icon> 0 Views
            </div>
          </div>
          <div *ngIf="candidateval.createdBy != userId">
            <div [title]="candidateval?.viewedByCount + ' Views'" class="ctr-stat-item" *ngIf="candidateval.viewedByCount > 0">
              <ng-icon name="tablerEye"></ng-icon> {{ candidateval?.viewedByCount | compactCount }} Views
            </div>
            <div class="ctr-stat-item" *ngIf="candidateval.viewedByCount == 0">
              <ng-icon name="tablerEye"></ng-icon> 0 Views
            </div>
          </div>

          <!-- Like/Unlike Heart Icon -->
          <div id="ctr_like_button" class="ctr-stat-item" *ngIf="candidateval?.isLiked != null" (click)="like(candidateval)">
            <ng-icon name="tablerHeart" class="pointer md-interaction-element" [ngClass]="candidateval.isLiked ? 'bg-heart liked' : 'icon-prime-color'"></ng-icon>
            <div id="ctr_likes_button" class="md-interaction-element" (click)="goTo(candidateval, 'Clike-like')"
              *ngIf="candidateval?.isLiked != null && candidateval.createdBy == userId">
              <span [title]="candidateval.likesCount + ' Likes'" class="blue-color">{{ candidateval.likesCount | compactCount }}</span>
              <span> Like<span *ngIf="candidateval.likesCount > 1">s</span></span>
            </div>
            <div class="md-interaction-element" style="cursor: context-menu;"
              *ngIf="candidateval?.isLiked != null && candidateval.createdBy != userId">
              <span [title]="candidateval.likesCount + ' Likes'" class="blue-color">{{ candidateval.likesCount | compactCount }}</span>
              <span> Like<span *ngIf="candidateval.likesCount > 1">s</span></span>
            </div>
          </div>
        </div>
      </div>

      <!-- Stage Column -->
      <div class="ctr-cell ctr-stage-col" *ngIf="(pageName == 'job-applicants' || pageName == 'candidate-applied') && showStatus">
        <div class="ctr-stage-dropdown" dropdown>
          <button id="ctr_status_dropdown_button" data-toggle="dropdown" dropdownToggle
            (click)="triggerChange(candidateval.candidateId)" class="ctr-stage-btn"
            aria-expanded="true" [ngStyle]="getStyle(candidateval?.currentStatus)">
            <ng-container>{{ getFilterValue(candidateval.currentStatus) | titlecase }}</ng-container>
            <ng-container *ngIf="pageName === 'job-applicants' && !isExcludedStatus(candidateval?.currentStatus) && candidateval?.canUpdateStatus !== false">
              <ng-icon name="tablerChevronDown"></ng-icon>
            </ng-container>
          </button>
          <ng-container *ngIf="!isExcludedStatus(candidateval?.currentStatus) && appliedJobDetails?.jobPostedBy == userId">
            <ul *dropdownMenu class="dropdown-menu ctr-stage-menu">
              <li role="menuitem" *ngFor="let statusData of filterApplicant(candidateval?.currentStatus, candidateval?.nextAllowedStatuses)"
                (click)="updatestatus(statusData, candidateval)" id="{{statusData?.item}}">
                <a id="{{statusData?.item}}"><ng-icon name="tablerCircle"></ng-icon>&nbsp;{{statusData?.item}}</a>
              </li>
            </ul>
          </ng-container>
        </div>
      </div>

      <!-- Quick Actions Column -->
      <div class="ctr-cell ctr-actions-col">
        <div class="ctr-action-buttons">
          <button id="ctr_view_profile" class="ctr-action-btn" title="View Profile"
            (click)="openCandidateInSlidePanel(candidateval)">
            <ng-icon name="tablerEye"></ng-icon>
          </button>

          <div *ngIf="candidateval?.resumes?.length > 0">
            <ng-container *ngFor="let item of candidateval?.resumes">
              <button id="ctr_download_resume" class="ctr-action-btn" title="Download Resume"
                *ngIf="item?.isDefault" (click)="downloadResume(candidateval, userId, item.fileId)">
                <ng-icon name="tablerDownload"></ng-icon>
              </button>
            </ng-container>
          </div>

          <button id="ctr_invite" class="ctr-action-btn" title="Invite to apply"
            *ngIf="candidateval.createdBy != userId && (userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')"
            (click)="invite(candidateval, connectionTemplate, jobsupplytemplate)">
            <ng-icon name="tablerSend"></ng-icon>
          </button>

          <button id="ctr_send_message" class="ctr-action-btn" title="Message"
            *ngIf="candidateval.createdBy != userId" (click)="openMessagecheckInteraction(candidateval, connectionTemplate)">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          </button>

          <!-- Documents Button with Badge -->
          <button id="ctr_documents" class="ctr-action-btn ctr-action-btn-primary" title="Candidate Document"
            *ngIf="candidateval?.docRequired && (pageName == 'job-applicants' || pageName == 'candidate-applied')"
            (click)="openDocuments()">
            <ng-icon name="tablerFileText"></ng-icon>
            <span class="ctr-doc-count-badge" *ngIf="totalMandatoryDocuments > 0">
              {{allVerified ? '✓' : totalMandatoryDocuments}}
            </span>
          </button>
        </div>
      </div>
    </div><!-- End of ctr-content -->

    <!-- Timeline Progress (full width below) -->
    <div class="ctr-timeline-progress" *ngIf="showTimeline && candidateval?.timelineStages?.length > 0">
      <div class="ctr-timeline-track">
        <ng-container *ngFor="let stage of candidateval?.timelineStages; let i = index; let last = last">
          <div class="ctr-timeline-step"
               [class.completed]="stage.completed"
               [class.active]="stage.active"
               [class.negative]="stage.isNegative"
               [class.terminal]="stage.isTerminal"
               [class.implied]="stage.isImplied"
               [class.future]="stage.notion === 'future'"
               [title]="stage.isImplied && stage.date ? (stage.label + ' - Skipped (reached higher stage on ' + (stage.date | timezoneDate:'dd MMM yyyy') + ')') : (stage.isImplied ? (stage.label + ' - Skipped (implied completion)') : (stage.completed && stage.date ? (stage.label + ' - Completed on ' + (stage.date | timezoneDate:'dd MMM yyyy')) : (stage.label + (stage.activityType ? ' (' + stage.activityType + ')' : ''))))">
            <div class="ctr-step-dot">
              <ng-icon name="tablerCheck" *ngIf="stage.completed && !stage.isTerminal"></ng-icon>
            </div>
            <span class="ctr-step-label">{{stage.label}}</span>
            <span class="ctr-step-date" *ngIf="stage.date">{{stage.date | timezoneDate:'dd MMM yyyy'}}</span>
          </div>
          <div class="ctr-timeline-connector"
               *ngIf="!last"
               [class.completed]="candidateval?.timelineStages[i + 1]?.completed && !stage.isTerminal"
               [class.negative]="stage.isNegative"></div>
        </ng-container>
      </div>
    </div>

  </div>
</ng-container>

<!-- ============================================================ -->
<!-- CONTRACT CARD VIEW - Card Layout for Contract Module Screens -->
<!-- ============================================================ -->
<ng-container *ngIf="viewSize == 'contract-card'">
  <div class="ctrc-card hpanel" [ngClass]="{
    'ctrc-disabled': !candidateval.availability || candidateval.status != 'ACTIVE',
    'ctrc-featured': candidateval?.isFeatured === true}">
    <div class="panel-body">

      <!-- Card Header Row -->
      <div class="ctrc-header">
        <div class="ctrc-candidate-section">
          <!-- Checkbox -->
          <div class="ctrc-checkbox" *ngIf="showCheckBox">
            <label class="checkbox-label font-normal">
              <input type="checkbox" (click)="selectCheckbox1($event, candidateval)"
                [(ngModel)]="candidateval.isSelected"
                (ngModelChange)="onNgModelChange($event, candidateval?.candidateId)" name="list_name" />
              <span class="checkmark"></span>
            </label>
          </div>

          <!-- Candidate Avatar -->
          <div class="ctrc-avatar" (click)="openCandidateInSlidePanel(candidateval)">
            <img *ngIf="candidateval?.user?.photo && candidateval?.user?.photo != 'null' && candidateval?.user?.photo != ''"
              [src]="url + candidateval.user.photo" alt="avatar" (error)="$event.target.style.display='none'">
            <div class="ctrc-avatar-initials"
              *ngIf="!candidateval?.user?.photo || candidateval?.user?.photo == 'null' || candidateval?.user?.photo == ''"
              [style.background-color]="getColor(candidateval?.firstName + ' ' + candidateval?.lastName)"
              [style.color]="getFullNameTextColor(candidateval?.firstName + ' ' + candidateval?.lastName)">
              {{getInitials(candidateval?.firstName + ' ' + candidateval?.lastName)}}
            </div>
          </div>

          <!-- Candidate Info -->
          <div class="ctrc-candidate-info" (click)="openCandidateInSlidePanel(candidateval)">
            <h3 class="ctrc-name">{{candidateval?.firstName}} {{candidateval?.lastName}}</h3>
            <span class="ctrc-title" *ngIf="candidateval?.jobTitle">{{candidateval?.jobTitle}}</span>
            <span class="ctrc-experience">{{candidateval?.totalExperience || 0}}+ Years Experience</span>
          </div>
        </div>

        <!-- Status Badge -->
        <div class="ctrc-status-section">
          <span class="ctrc-status-badge" [ngStyle]="getStyle(candidateval?.currentStatus || candidateval?.status)">
            {{ getFilterValue(candidateval?.currentStatus || candidateval?.status) | titlecase }}
          </span>
          <div *ngIf="candidateval?.latest && candidateval.latest == true" class="ctrc-new-badge">New</div>
        </div>
      </div>

      <!-- Card Body - Info Grid -->
      <div class="ctrc-body">
        <!-- Owner Info -->
        <div class="ctrc-info-row" *ngIf="candidateval?.user?.fullname">
          <div class="ctrc-info-icon">
            <ng-icon name="tablerUser"></ng-icon>
          </div>
          <span class="ctrc-info-label">Owner:</span>
          <span class="ctrc-info-value">{{candidateval?.user?.fullname}}</span>
        </div>

        <!-- Location -->
        <div class="ctrc-info-row" *ngIf="candidateval?.city || candidateval?.state">
          <div class="ctrc-info-icon">
            <ng-icon name="tablerMapPin" class="ctrc-svg-icon"></ng-icon>
          </div>
          <span class="ctrc-info-label">Location:</span>
          <span class="ctrc-info-value">
            {{candidateval?.city}}<span *ngIf="candidateval?.city && candidateval?.state">, </span>{{candidateval?.state}}
          </span>
        </div>

        <!-- Work Mode -->
        <div class="ctrc-info-row" *ngIf="candidateval?.workMode">
          <div class="ctrc-info-icon">
            <ng-icon name="tablerBriefcase"></ng-icon>
          </div>
          <span class="ctrc-info-label">Work Mode:</span>
          <span class="ctrc-info-value ctrc-work-mode-badge">{{candidateval?.workMode}}</span>
        </div>

        <!-- Availability -->
        <div class="ctrc-info-row">
          <div class="ctrc-info-icon">
            <ng-icon name="tablerCalendar"></ng-icon>
          </div>
          <span class="ctrc-info-label">Available:</span>
          <span class="ctrc-info-value">{{candidateval?.availableIn || '2 weeks'}}</span>
        </div>

        <!-- Skills -->
        <div class="ctrc-skills-section" *ngIf="getAllSkills(candidateval)?.length > 0">
          <div class="ctrc-skills-label">Skills:</div>
          <div class="ctrc-skills-container">
            <span class="ctrc-skill-tag" *ngFor="let skill of getAllSkills(candidateval).slice(0, 4)">
              {{skill}}
            </span>
            <span class="ctrc-skill-more" *ngIf="getAllSkills(candidateval).length > 4">
              +{{getAllSkills(candidateval).length - 4}} more
            </span>
          </div>
        </div>
      </div>

      <!-- Document Progress Section -->
      <div class="ctrc-documents-section" *ngIf="candidateval?.docRequired">
        <div class="ctrc-doc-header">
          <span class="ctrc-doc-label">
            <ng-icon name="tablerFileText"></ng-icon> Documents
          </span>
          <span class="ctrc-doc-count" [ngClass]="{'ctrc-complete': allVerified, 'ctrc-pending': !allVerified}">
            {{allVerified ? 'Complete' : (totalMandatoryDocuments || 0) + ' Required'}}
          </span>
        </div>
        <div class="ctrc-doc-progress">
          <div class="ctrc-progress-bar">
            <div class="ctrc-progress-fill"
              [style.width.%]="allVerified ? 100 : (totalMandatoryDocuments > 0 ? ((totalMandatoryDocuments - (totalMandatoryDocuments || 0)) / totalMandatoryDocuments * 100) : 0)"
              [ngClass]="{'ctrc-complete': allVerified}"></div>
          </div>
        </div>
      </div>

      <!-- Engagement Stats -->
      <div class="ctrc-engagement">
        <div class="ctrc-stat" *ngIf="candidateval?.viewedByCount >= 0">
          <ng-icon name="tablerEye"></ng-icon>
          <span [title]="candidateval?.viewedByCount + ' Views'">{{ candidateval?.viewedByCount | compactCount }} Views</span>
        </div>
        <div class="ctrc-stat" *ngIf="candidateval?.likesCount >= 0">
          <ng-icon name="tablerHeart" [ngClass]="candidateval?.isLiked ? 'ctrc-liked' : ''"></ng-icon>
          <span [title]="candidateval?.likesCount + ' Likes'">{{ candidateval?.likesCount | compactCount }} Likes</span>
        </div>
        <div class="ctrc-stat" *ngIf="candidateval?.updatedOn">
          <ng-icon name="tablerClock"></ng-icon>
          <span>{{candidateval?.updatedOn | timezoneDate:'MM/dd/yyyy'}}</span>
        </div>
      </div>

      <!-- Card Actions -->
      <div class="ctrc-actions">
        <button class="ctrc-action-btn ctrc-primary" (click)="openCandidateInSlidePanel(candidateval)" title="View Profile">
          <ng-icon name="tablerEye"></ng-icon> View
        </button>

        <ng-container *ngIf="candidateval?.resumes?.length > 0">
          <ng-container *ngFor="let item of candidateval?.resumes">
            <button class="ctrc-action-btn" *ngIf="item?.isDefault"
              (click)="downloadResume(candidateval, userId, item.fileId)" title="Download Resume">
              <ng-icon name="tablerDownload"></ng-icon>
            </button>
          </ng-container>
        </ng-container>

        <button class="ctrc-action-btn" *ngIf="candidateval.createdBy != userId"
          (click)="openMessagecheckInteraction(candidateval, connectionTemplate)" title="Message">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
        </button>

        <button class="ctrc-action-btn ctrc-docs" *ngIf="candidateval?.docRequired"
          (click)="openDocuments()" title="Candidate Document">
          <ng-icon name="tablerFileText"></ng-icon>
          <span class="ctrc-doc-badge" *ngIf="totalMandatoryDocuments > 0 && !allVerified">
            {{totalMandatoryDocuments}}
          </span>
        </button>
      </div>

      <!-- Timeline Progress (Collapsible) -->
      <div class="ctrc-timeline-section" *ngIf="showTimeline && candidateval?.timelineStages?.length > 0">
        <div class="ctrc-timeline-header">
          <span class="ctrc-timeline-title">
            <ng-icon name="tablerListCheck"></ng-icon> Application Progress
          </span>
        </div>
        <div class="ctrc-timeline-track">
          <ng-container *ngFor="let stage of candidateval?.timelineStages; let i = index; let last = last">
            <div class="ctrc-timeline-step"
                 [class.completed]="stage.completed"
                 [class.active]="stage.active"
                 [class.negative]="stage.isNegative"
                 [class.terminal]="stage.isTerminal"
                 [class.implied]="stage.isImplied"
                 [title]="stage.label + (stage.date ? ' - ' + (stage.date | timezoneDate:'dd MMM yyyy') : '')">
              <div class="ctrc-step-dot">
                <ng-icon name="tablerCheck" *ngIf="stage.completed && !stage.isTerminal"></ng-icon>
                <ng-icon name="tablerX" *ngIf="stage.isTerminal"></ng-icon>
              </div>
              <span class="ctrc-step-label">{{stage.label}}</span>
            </div>
            <div class="ctrc-timeline-connector" *ngIf="!last"
                 [class.completed]="candidateval?.timelineStages[i + 1]?.completed && !stage.isTerminal"
                 [class.negative]="stage.isNegative"></div>
          </ng-container>
        </div>
      </div>

    </div>
  </div>
</ng-container>

<!-- ============================================================ -->
<!-- CONTRACT LARGE VIEW - Original Large Design for Contract Module -->
<!-- All classes prefixed with ctl- to avoid conflicts -->
<!-- ============================================================ -->
<ng-container *ngIf="viewSize == 'contract-large'">
  <div class="ctl-hpanel">
    <div class="ctl-panel-body" [ngClass]="{
      'ctl-disabled': !candidateval.availability || candidateval.status != 'ACTIVE',
      'ctl-featured': candidateval?.isFeatured === true,
      'ctl-selected': candidateval.isSelected}">
      <div class="ctl-card-container">

        <!-- Left Section - Owner Details -->
        <div class="ctl-user-detail">
          <div class="ctl-checkbox-wrapper" *ngIf="showCheckBox">
            <label class="checkbox-label font-normal">
              <input type="checkbox" (click)="selectCheckbox1($event, candidateval)"
                [(ngModel)]="candidateval.isSelected"
                (ngModelChange)="onNgModelChange($event, candidateval?.candidateId)" name="list_name" />
              <span class="checkmark"></span>
            </label>
          </div>

          <div class="ctl-owner-section">
            <div class="ctl-owner-profile-img">
              <!-- Role Badges -->
              <span class="ctl-role-badge" *ngIf="candidateval?.user?.userType == 'FREELANCE_RECRUITER'" title="Freelance Recruiter">FR</span>
              <span class="ctl-role-badge" *ngIf="candidateval?.user?.userType == 'student'" title="Student">ST</span>
              <span class="ctl-role-badge" *ngIf="candidateval?.user?.userType == 'JOB_SEEKER'" title="Job Seeker">JS</span>

              <!-- Profile Image/Initials -->
              <div *ngIf="candidateval?.user?.photo && candidateval?.user?.photo != 'null' && candidateval?.user?.photo != ''">
                <img [src]="url + candidateval?.user?.photo" alt="profile-picture" (error)="$event.target.style.display='none'">
              </div>
              <div *ngIf="!candidateval?.user?.photo || candidateval?.user?.photo == 'null' || candidateval?.user?.photo == ''">
                <div class="ctl-circles" [style.background-color]="getColor(candidateval?.user?.fullname)">
                  <div class="ctl-circle-text" [style.color]="getFullNameTextColor(candidateval?.user?.fullname)">
                    {{ getInitials(candidateval?.user?.fullname) }}
                  </div>
                </div>
              </div>
            </div>

            <div class="ctl-owner-info">
              <h6 class="ctl-owner-name" title="{{candidateval?.user?.fullname}}">
                {{candidateval?.user?.fullname}}
              </h6>

              <!-- Owner's current organization -->
              <div class="ctl-owner-org" *ngIf="hasCurrentOrganization">
                <span *ngFor="let work of candidateval?.user?.workExperience">
                  <span *ngIf="work?.currentOrganization" title="{{work?.organisationName}}">
                    {{work?.organisationName}}
                  </span>
                </span>
              </div>

              <div class="ctl-owner-timestamp" *ngIf="candidateval.postedOn">
                {{candidateval?.postedOn | timezoneDate:'MM/dd/yyyy'}}
              </div>
              <div class="ctl-owner-timestamp" *ngIf="candidateval.updatedOn">
                {{candidateval?.updatedOn | timezoneDate:'MM/dd/yyyy'}}
              </div>
            </div>
          </div>
        </div>

        <!-- Middle Section - Candidate Details -->
        <div class="ctl-card-detail">
          <div class="ctl-candidate-header">
            <div class="ctl-candidate-name-section">
              <div class="ctl-candidate-name" *ngIf="candidateval?.firstName"
                title="{{candidateval.firstName | titlecase}} {{candidateval.lastName | titlecase}}"
                (click)="openCandidateInSlidePanel(candidateval)">
                {{candidateval.firstName | titlecase}} {{candidateval.lastName | titlecase}}
              </div>

              <div class="ctl-candidate-experience">
                Experience: {{candidateval.totalExperience || 0}} Years
              </div>
            </div>

            <!-- Skills Section -->
            <div class="ctl-skills-container">
              <div class="ctl-skills">
                <div *ngFor="let data of (skillsExpanded ? candidateval?.primarySkills : candidateval?.primarySkills?.slice(0, 3)); let i = index;">
                  <div title="{{data}}" class="ctl-skill-badge">{{data}}</div>
                </div>

                <div class="ctl-skill-more-btn"
                     *ngIf="candidateval?.primarySkills?.length > 3"
                     (click)="toggleSkills(); $event.stopPropagation()">
                  <span *ngIf="!skillsExpanded">+{{candidateval?.primarySkills?.length - 3}} more</span>
                  <span *ngIf="skillsExpanded">Show less</span>
                </div>
              </div>
            </div>
          </div>

          <div class="ctl-details-grid" (click)="openCandidateInSlidePanel(candidateval)">
            <div class="ctl-detail-item" title="{{candidateval.clientName}}" *ngIf="candidateval.showClientName">
              <ng-icon name="tablerBuilding" class="ctl-svg-icon"></ng-icon>
              {{candidateval.clientName | truncate:20}}
            </div>

            <div class="ctl-detail-item" *ngIf="candidateval.city || candidateval.state">
              <ng-icon name="tablerMapPin" class="ctl-svg-icon"></ng-icon>
              <span title="{{candidateval.city}}">{{candidateval.city}}</span>
              <span title="{{candidateval.state}}" *ngIf="candidateval.state">, {{candidateval.state}}</span>
            </div>

            <div class="ctl-detail-item" *ngIf="candidateval.targetRateFrom || candidateval.targetRateTo">
              <span title="{{candidateval.targetRateFrom}} - {{candidateval.targetRateTo}}">
                {{candidateval.country == 'US' ? "$" : ""}} {{candidateval.targetRateFrom}} - {{candidateval.targetRateTo}}
              </span>
              <span *ngIf="candidateval?.country == 'US'"> USD / </span>
              <span *ngIf="candidateval?.country == 'IN'"> INR / </span>
              <span *ngIf="candidateval?.country == 'CA'"> CAD / </span>
              <span *ngIf="candidateval?.country == 'AU'"> AUD / </span>
              <value-template #valueProvider="handleValue">
                <span title="{{valueProvider.getValue(candidateval)}}">{{valueProvider.getValues(candidateval)}}</span>
              </value-template>
            </div>

            <div *ngIf="candidateval?.workMode" class="ctl-detail-item" title="{{candidateval.workMode}}">
              <ng-icon name="tablerMapPin" class="ctl-svg-icon"></ng-icon>
              {{candidateval.workMode}}
            </div>
          </div>

          <!-- Interactive Elements -->
          <div class="ctl-interactive-elements">
            <!-- Views -->
            <div class="ctl-interaction-item" *ngIf="candidateval.createdBy == userId && candidateval.viewedByCount > 0"
              (click)="goTo(candidateval, 'views')">
              <ng-icon name="tablerEye" class="ctl-icon"></ng-icon>
              <span [title]="candidateval.viewedByCount + ' Views'" class="ctl-count">{{ candidateval.viewedByCount | compactCount }}</span> Views
            </div>
            <div class="ctl-interaction-item" *ngIf="candidateval.createdBy == userId && candidateval.viewedByCount == 0"
              (click)="goTo(candidateval, 'Noviews')">
              <ng-icon name="tablerEye" class="ctl-icon"></ng-icon>
              <span class="ctl-count">0</span> Views
            </div>
            <div class="ctl-interaction-item ctl-no-click" *ngIf="candidateval.createdBy != userId">
              <ng-icon name="tablerEye" class="ctl-icon"></ng-icon>
              <span [title]="candidateval.viewedByCount + ' Views'" class="ctl-count">{{ candidateval.viewedByCount | compactCount }}</span> Views
            </div>

            <!-- Like Button -->
            <div class="ctl-interaction-item" *ngIf="candidateval?.isLiked != null" (click)="like(candidateval)">
              <ng-icon name="tablerHeart" class="ctl-icon" [ngClass]="candidateval.isLiked ? 'ctl-liked' : ''"></ng-icon>
            </div>

            <!-- Likes Count -->
            <div class="ctl-interaction-item" *ngIf="candidateval.createdBy == userId"
              (click)="goTo(candidateval, 'Clike-like')">
              <span [title]="candidateval.likesCount + ' Likes'" class="ctl-count">{{ candidateval.likesCount | compactCount }}</span>
              Like<span *ngIf="candidateval.likesCount > 1">s</span>
            </div>
            <div class="ctl-interaction-item ctl-no-click" *ngIf="candidateval.createdBy != userId">
              <span [title]="candidateval.likesCount + ' Likes'" class="ctl-count">{{ candidateval.likesCount | compactCount }}</span>
              Like<span *ngIf="candidateval.likesCount > 1">s</span>
            </div>

            <!-- Invites -->
            <div class="ctl-interaction-item" *ngIf="candidateval.createdBy == userId"
              (click)="goTo(candidateval, 'cInvited')" title="Invites Received Count">
              <ng-icon name="tablerMail" class="ctl-svg-icon"></ng-icon>
              <span class="ctl-count">{{ candidateval.interestShownCount | compactCount }}</span>
              <span class="ctl-new-count" *ngIf="candidateval.appliedToday > 0">({{candidateval.appliedToday}} new)</span>
              Invites
            </div>

            <!-- Jobs Applied -->
            <div class="ctl-interaction-item" *ngIf="candidateval.createdBy === userId"
              (click)="goTo(candidateval, 'jobsApplied')" title="Job Applied Count">
              <ng-icon name="tablerSend" class="ctl-svg-icon"></ng-icon>
              <span class="ctl-count">{{ candidateval?.jobsAppliedCount | compactCount }}</span>
              Applied
            </div>

            <!-- Download Resume -->
            <ng-container *ngFor="let item of candidateval?.resumes">
              <div class="ctl-interaction-item" *ngIf="item?.isDefault">
                <a (click)="downloadResume(candidateval, userId, item.fileId)" target="_blank" download>
                  <ng-icon name="tablerDownload" class="ctl-icon"></ng-icon> Download Resume
                </a>
              </div>
            </ng-container>

            <!-- Invite to Apply -->
            <div class="ctl-interaction-item" title="Invite to Apply"
              (click)="invite(candidateval, connectionTemplate, jobsupplytemplate)"
              *ngIf="candidateval.createdBy != userId && (userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')">
              <ng-icon name="tablerMail" class="ctl-svg-icon"></ng-icon>
              Invite To Apply
            </div>

            <!-- Chat -->
            <div class="ctl-interaction-item" *ngIf="candidateval.chatHistoryCount > 0"
              (click)="openMessagecheckInteraction(candidateval, connectionTemplate)"
              title="{{candidateval.nonSeenMessageCount}} Messages">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="ctl-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
              <span class="ctl-count" *ngIf="candidateval.nonSeenMessageCount > 0">{{candidateval.nonSeenMessageCount}}</span>
              Chat
            </div>
            <div class="ctl-interaction-item" *ngIf="candidateval.createdBy != userId && candidateval.chatHistoryCount == 0"
              (click)="openMessagecheckInteraction(candidateval, connectionTemplate)">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="ctl-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg> Chat
            </div>
          </div>
        </div>

        <!-- Right Section - Status -->
        <div class="ctl-card-status">
          <div class="ctl-status-section">
            <!-- Status Dropdown Button -->
            <div class="btn-group" dropdown *ngIf="showStatus && (pageName == 'job-applicants' || pageName == 'candidate-applied')">
              <button dropdownToggle (click)="triggerChange(candidateval.candidateId)"
                class="ctl-status-btn dropdown-toggle" [ngStyle]="getStyle(candidateval.currentStatus)">
                <span>{{candidateval.currentStatus | titlecase}}</span>
                <ng-container *ngIf="!isExcludedStatus(candidateval?.currentStatus) && appliedJobDetails?.jobPostedBy == userId">
                  <ng-icon name="tablerChevronDown" class="ctl-chevron"></ng-icon>
                </ng-container>
              </button>
              <ng-container *ngIf="!isExcludedStatus(candidateval?.currentStatus) && appliedJobDetails?.jobPostedBy == userId">
                <ul *dropdownMenu class="dropdown-menu ctl-status-dropdown">
                  <li role="menuitem" *ngFor="let statusData of filterApplicant(candidateval?.currentStatus, candidateval?.nextAllowedStatuses)"
                    (click)="updatestatus(statusData, candidateval)">
                    <a><ng-icon name="tablerCircle"></ng-icon>&nbsp;{{statusData?.item}}</a>
                  </li>
                </ul>
              </ng-container>
            </div>

            <!-- Non-dropdown Status -->
            <button class="ctl-status-btn" *ngIf="!showStatus || (pageName != 'job-applicants' && pageName != 'candidate-applied')"
              [ngStyle]="getStyle(candidateval.currentStatus || candidateval.status)">
              <ng-container *ngIf="candidateval.status == 'ACTIVE' && !candidateval.currentStatus">Available</ng-container>
              <ng-container *ngIf="candidateval.status == 'INACTIVE' && !candidateval.currentStatus">Unavailable</ng-container>
              <ng-container *ngIf="candidateval.status == 'DRAFTED'">Draft</ng-container>
              <ng-container *ngIf="candidateval.currentStatus">{{candidateval.currentStatus | titlecase}}</ng-container>
            </button>

            <!-- Action Menu -->
            <div class="btn-group ctl-action-menu" dropdown>
              <a dropdownToggle class="ctl-action-trigger">
                <ng-icon name="tablerDotsVertical"></ng-icon>
              </a>
              <ul *dropdownMenu class="dropdown-menu ctl-action-dropdown">
                <li role="menuitem">
                  <a (click)="openCandidateInSlidePanel(candidateval)">View Profile</a>
                </li>
                <li role="menuitem" *ngIf="reportEnabled && candidateval.createdBy != userId">
                  <app-flag type="CANDIDATE" [id]="candidateval.candidateId" [flagTo]="candidateval.createdBy"
                    [flags]="['Report Candidate as fake.']">
                  </app-flag>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- ============================================================ -->
<!-- CONTRACT ROW DESIGN - Copy of row-design for Contract Module -->
<!-- No ranking, no scoring, with Owner column -->
<!-- All classes prefixed with ctrd- to avoid conflicts -->
<!-- ============================================================ -->
<!-- CONTRACT ROW DESIGN - Matching reference design 20.png -->
<ng-container *ngIf="viewSize == 'contract-row-design'">
  <div class="ctrd-card" [ngClass]="{
    'ctrd-disabled': !candidateval.availability || candidateval.status != 'ACTIVE',
    'ctrd-featured': candidateval?.isFeatured === true,
    'ctrd-selected': candidateval.isSelected}">

    <!-- Left Section: Supplier Info + Actions -->
    <div class="ctrd-supplier-section">
      <div class="ctrd-supplier-info">
        <!-- Supplier Avatar -->
        <div class="ctrd-supplier-avatar"
          [style.background-color]="getColor(candidateval?.contractData?.supplierName || candidateval?.user?.fullname)">
          <span class="ctrd-supplier-initials">
            {{getInitials(candidateval?.contractData?.supplierName || candidateval?.user?.fullname)}}
          </span>
        </div>
        <!-- Supplier Details -->
        <div class="ctrd-supplier-details">
          <div class="ctrd-supplier-name">{{candidateval?.contractData?.supplierName || candidateval?.user?.fullname}}</div>
          <div class="ctrd-customer-name">{{candidateval?.contractData?.customerName}}</div>
          <ng-container *ngIf="!candidateval?.contractData?.customerName">
            <ng-container *ngFor="let work of candidateval?.user?.workExperience">
              <div class="ctrd-customer-name" *ngIf="work?.currentOrganization">{{work?.organisationName}}</div>
            </ng-container>
          </ng-container>
          <div class="ctrd-timestamp">{{candidateval?.updatedOn | timezoneDate:'MM/dd/yyyy'}}</div>
        </div>
      </div>
      <!-- Action Buttons -->
      <div class="ctrd-action-buttons">
        <button class="ctrd-action-btn" title="View Profile" (click)="openCandidateInSlidePanel(candidateval)">
          <ng-icon name="tablerEye"></ng-icon>
        </button>
        <button class="ctrd-action-btn" title="Message"
          (click)="openMessagecheckInteraction(candidateval, connectionTemplate)">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
        </button>
        <button class="ctrd-action-btn ctrd-action-btn-primary" title="Candidate Document"
          (click)="openDocuments()">
          <ng-icon name="tablerFileText"></ng-icon>
        </button>
        <button class="ctrd-action-btn" title="More Options" dropdown>
          <ng-icon name="tablerDots" dropdownToggle></ng-icon>
          <ul *dropdownMenu class="dropdown-menu ctrd-dropdown-menu">
            <li><a (click)="shareProfile(candidateval)">Share Profile</a></li>
            <li><a (click)="scheduleInterview(candidateval)">Schedule Interview</a></li>
            <li><a (click)="addNotes(candidateval)">Add Notes</a></li>
          </ul>
        </button>
      </div>
    </div>

    <!-- Center Section: Candidate Info -->
    <div class="ctrd-candidate-section" (click)="openCandidateInSlidePanel(candidateval)">
      <div class="ctrd-candidate-avatar"
        [style.background-color]="getColor(candidateval?.firstName + ' ' + candidateval?.lastName)">
        <span class="ctrd-candidate-initials"
          [style.color]="getFullNameTextColor(candidateval?.firstName + ' ' + candidateval?.lastName)">
          {{getInitials(candidateval?.firstName + ' ' + candidateval?.lastName)}}
        </span>
      </div>
      <div class="ctrd-candidate-details">
        <div class="ctrd-candidate-name">{{candidateval?.firstName}} {{candidateval?.lastName}}</div>
        <div class="ctrd-candidate-experience">{{candidateval?.totalExperience || 0}}+ Years</div>
      </div>
    </div>

    <!-- Right Section: Job Details -->
    <div class="ctrd-job-section">
      <div class="ctrd-job-title">{{candidateval?.jobTitle}}</div>
      <div class="ctrd-candidate-id">Candidate ID: {{candidateval?.candidateId}}</div>
      <div class="ctrd-availability">Available: {{candidateval?.availableIn || '2 weeks'}}</div>
    </div>

    <!-- Far Right Section: Engagement + Status -->
    <div class="ctrd-status-section">
      <div class="ctrd-engagement">
        <div [title]="candidateval?.viewedByCount + ' Views'" class="ctrd-stat-item">
          <ng-icon name="tablerEye"></ng-icon> {{ candidateval?.viewedByCount | compactCount }} Views
        </div>
        <div [title]="candidateval?.likesCount + ' Likes'" class="ctrd-stat-item">
          <ng-icon name="tablerHeart" [class.ctrd-liked]="candidateval?.isLiked" (click)="like(candidateval)"></ng-icon>
          {{ candidateval?.likesCount | compactCount }} Like{{candidateval?.likesCount > 1 ? 's' : ''}}
        </div>
      </div>
      <!-- Status Dropdown -->
      <div class="ctrd-status-dropdown" *ngIf="showStatus" dropdown>
        <button class="ctrd-status-btn" dropdownToggle
          [ngStyle]="getStyle(candidateval?.currentStatus)"
          (click)="triggerChange(candidateval.candidateId)">
          <span>{{ getFilterValue(candidateval?.currentStatus) | titlecase }}</span>
          <ng-icon name="tablerChevronDown" *ngIf="!isExcludedStatus(candidateval?.currentStatus)"></ng-icon>
        </button>
        <ul *dropdownMenu class="dropdown-menu ctrd-dropdown-menu">
          <li *ngFor="let statusData of filterApplicant(candidateval?.currentStatus, candidateval?.nextAllowedStatuses)"
            (click)="updatestatus(statusData, candidateval)">
            <a><ng-icon name="tablerCircle"></ng-icon> {{statusData?.item}}</a>
          </li>
        </ul>
      </div>
    </div>

  </div>
</ng-container>

<!-- ============================================================ -->
<!-- CONTRACT ROW V3 - New Card Row Design for Contract Module -->
<!-- Following Work Order List design pattern -->
<!-- All classes prefixed with ctrv3- to avoid conflicts -->
<!-- ============================================================ -->
<ng-container *ngIf="viewSize == 'contract-row-v3'">
  <div class="ctrv3-card" [ngClass]="{
    'ctrv3-featured': candidateval?.isFeatured === true,
    'ctrv3-selected': candidateval.isSelected}">

    <!-- Candidate Column -->
    <div class="ctrv3-col ctrv3-candidate-col" (click)="openCandidateInSlidePanel(candidateval)">
      <div class="ctrv3-candidate-info">
        <!-- Avatar -->
        <div class="ctrv3-avatar">
          <img *ngIf="candidateval?.user?.photo && candidateval?.user?.photo != 'null' && candidateval?.user?.photo != ''"
            [src]="url + candidateval.user.photo" alt="avatar" (error)="$event.target.style.display='none'">
          <span class="ctrv3-avatar-initials"
            *ngIf="!candidateval?.user?.photo || candidateval?.user?.photo == 'null' || candidateval?.user?.photo == ''"
            [style.background-color]="getColor(candidateval?.firstName + ' ' + candidateval?.lastName)"
            [style.color]="getFullNameTextColor(candidateval?.firstName + ' ' + candidateval?.lastName)">
            {{getInitials(candidateval?.firstName + ' ' + candidateval?.lastName)}}
          </span>
        </div>
        <!-- Candidate Details -->
        <div class="ctrv3-candidate-details">
          <span class="ctrv3-candidate-name" [title]="(candidateval?.firstName || '') + ' ' + (candidateval?.lastName || '')">{{candidateval?.firstName}} {{candidateval?.lastName}}</span>
          <span class="ctrv3-candidate-experience">{{candidateval?.totalExperience || 0}}+ Years Exp</span>
          <span class="ctrv3-candidate-id" *ngIf="candidateval?.candidateId">ID: {{candidateval?.candidateId}}</span>
          <span class="ctrv3-candidate-status-badge" *ngIf="candidateval?.candidateStatus"
                [ngStyle]="getStyle(candidateval.candidateStatus)">
            {{candidateval.candidateStatus === 'ACTIVE' ? 'Available' : candidateval.candidateStatus === 'INACTIVE' ? 'Unavailable' : candidateval.candidateStatus === 'BLOCKED' ? 'Blocked' : candidateval.candidateStatus}}
          </span>
        </div>
      </div>
    </div>

    <!-- Job Details Column -->
    <div class="ctrv3-col ctrv3-job-col">
      <div class="ctrv3-job-info">
        <span class="ctrv3-job-title" [title]="candidateval?.contractData?.jobTitle || candidateval?.jobTitle || 'N/A'">{{candidateval?.contractData?.jobTitle || candidateval?.jobTitle || 'N/A'}}</span>
        <span class="ctrv3-job-id" *ngIf="candidateval?.contractData?.jobId || appliedJobDetails?.jobId">
          Job ID: {{candidateval?.contractData?.jobId || appliedJobDetails?.jobId}}
        </span>
        <span class="ctrv3-work-mode" *ngIf="candidateval?.workMode">
          {{candidateval?.workMode}}
        </span>
      </div>
    </div>

    <!-- Location Column -->
    <div class="ctrv3-col ctrv3-location-col">
      <div class="ctrv3-location-info">
        <ng-icon name="tablerMapPin" class="ctrv3-location-icon"></ng-icon>
        <span class="ctrv3-location-text" *ngIf="candidateval?.city || candidateval?.state"
          [title]="(candidateval?.city || '') + (candidateval?.city && candidateval?.state ? ', ' : '') + (candidateval?.state || '')">
          {{candidateval?.city}}<span *ngIf="candidateval?.city && candidateval?.state">, </span>{{candidateval?.state}}
        </span>
        <span class="ctrv3-location-text ctrv3-na" *ngIf="!candidateval?.city && !candidateval?.state">N/A</span>
      </div>
    </div>

    <!-- Customer Column -->
    <div class="ctrv3-col ctrv3-customer-col">
      <div class="ctrv3-company-info">
        <ng-icon name="tablerBuilding" class="ctrv3-company-icon"></ng-icon>
        <span class="ctrv3-company-name" *ngIf="candidateval?.contractData?.customerName" [title]="candidateval?.contractData?.customerName">
          {{candidateval?.contractData?.customerName}}
        </span>
        <span class="ctrv3-company-name ctrv3-na" *ngIf="!candidateval?.contractData?.customerName">N/A</span>
      </div>
    </div>

    <!-- Supplier Column -->
    <div class="ctrv3-col ctrv3-supplier-col">
      <div class="ctrv3-company-info">
        <ng-icon name="tablerNetwork" class="ctrv3-company-icon"></ng-icon>
        <span class="ctrv3-company-name" *ngIf="candidateval?.contractData?.supplierName" [title]="candidateval?.contractData?.supplierName">
          {{candidateval?.contractData?.supplierName}}
        </span>
        <span class="ctrv3-company-name" *ngIf="!candidateval?.contractData?.supplierName && candidateval?.user?.fullname" [title]="candidateval?.user?.fullname">
          {{candidateval?.user?.fullname}}
        </span>
        <span class="ctrv3-company-name ctrv3-na" *ngIf="!candidateval?.contractData?.supplierName && !candidateval?.user?.fullname">N/A</span>
      </div>
    </div>

    <!-- Bill/Pay Rates Column -->
    <div class="ctrv3-col ctrv3-rates-col">
      <div class="ctrv3-rates-info">
        <span class="ctrv3-bill-rate" *ngIf="candidateval?.contractData?.billRate">
          {{candidateval?.contractData?.billRate | currency:'USD':'symbol':'1.2-2'}}
          <span class="ctrv3-rate-type">{{candidateval?.contractData?.rateType ? candidateval?.contractData?.rateType : 'hr'}}</span>
        </span>
        <span class="ctrv3-pay-rate" *ngIf="candidateval?.contractData?.payRate">
          Pay: {{candidateval?.contractData?.payRate | currency:'USD':'symbol':'1.2-2'}}
          <span class="ctrv3-rate-type">{{candidateval?.contractData?.rateType ? candidateval?.contractData?.rateType : 'hr'}}</span>
        </span>
        <span class="ctrv3-margin" *ngIf="candidateval?.contractData?.billRate && candidateval?.contractData?.payRate">
          {{((candidateval?.contractData?.billRate - candidateval?.contractData?.payRate) / candidateval?.contractData?.billRate * 100) | number:'1.0-1'}}% margin
        </span>
        <span class="ctrv3-rates-na" *ngIf="!candidateval?.contractData?.billRate && !candidateval?.contractData?.payRate">
          --
        </span>
      </div>
    </div>

    <!-- Status Column -->
    <div class="ctrv3-col ctrv3-status-col">
      <div class="ctrv3-status-wrapper" *ngIf="showStatus" ngbDropdown placement="bottom-left" container="body">
        <button class="ctrv3-status-btn" ngbDropdownToggle
          [ngStyle]="getStyle(candidateval?.currentStatus || candidateval?.status)"
          [disabled]="!isContractStatusEnabled()"
          (click)="triggerChange(candidateval.candidateId)">
          <span>{{ contractGetFilterValue(candidateval?.currentStatus || candidateval?.status) || (candidateval?.currentStatus || candidateval?.status) | titlecase }}</span>
          <ng-icon name="tablerChevronDown" *ngIf="!isExcludedStatus(candidateval?.currentStatus || candidateval?.status) && isContractStatusEnabled()"></ng-icon>
        </button>
        <div ngbDropdownMenu class="ctrv3-status-dropdown-menu" *ngIf="!isExcludedStatus(candidateval?.currentStatus || candidateval?.status) && isContractStatusEnabled()">
          <button ngbDropdownItem *ngFor="let statusData of contractFilterApplicant(candidateval?.currentStatus || candidateval?.status, candidateval?.nextAllowedStatuses)"
            (click)="contractUpdateStatus(statusData, candidateval)">
            <ng-icon name="tablerCircle"></ng-icon> {{statusData?.item}}
          </button>
        </div>
      </div>
      <div class="ctrv3-status-badge" *ngIf="!showStatus"
        [ngStyle]="getStyle(candidateval?.currentStatus || candidateval?.status)">
        {{ contractGetFilterValue(candidateval?.currentStatus || candidateval?.status) || (candidateval?.currentStatus || candidateval?.status) | titlecase }}
      </div>
    </div>

    <!-- Contract Status Column -->
    <div class="ctrv3-col ctrv3-contract-status-col">
      <span class="ctrv3-tracking-badge"
        [ngClass]="getTrackingStatusClass(candidateval?.contractData?.contractTrackingStatus || 'NOT_INITIATED')">
        {{getTrackingStatusLabel(candidateval?.contractData?.contractTrackingStatus || 'NOT_INITIATED')}}
      </span>
    </div>

    <!-- Actions Column -->
    <div class="ctrv3-col ctrv3-actions-col">
      <div class="ctrv3-action-buttons">
        <!-- View Profile -->
        <button class="ctrv3-action-btn" title="View Profile" (click)="openCandidateInSlidePanel(candidateval)">
          <ng-icon name="tablerEye" class="ctrv3-action-icon"></ng-icon>
        </button>

        <!-- Message: has chat history → clickable for everyone -->
        <button class="ctrv3-action-btn" title="{{candidateval.nonSeenMessageCount}} Messages"
          *ngIf="candidateval.chatHistoryCount > 0"
          (click)="openMessagecheckInteraction(candidateval, connectionTemplate)">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="ctrv3-action-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          <span class="blue-color" *ngIf="candidateval.nonSeenMessageCount > 0">{{candidateval.nonSeenMessageCount}}</span>
        </button>

        <!-- Message: not owner, no history → can initiate -->
        <button class="ctrv3-action-btn" title="No Messages"
          *ngIf="candidateval.createdBy != userId && candidateval.chatHistoryCount == 0"
          (click)="openMessagecheckInteraction(candidateval, connectionTemplate)">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="ctrv3-action-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
        </button>

        <!-- Message: owner, no history → visible but not clickable -->
        <button class="ctrv3-action-btn" title="No Messages"
          *ngIf="candidateval.createdBy == userId && candidateval.chatHistoryCount == 0">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="ctrv3-action-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
        </button>

        <!-- Documents -->
        <button class="ctrv3-action-btn ctrv3-action-docs" title="Candidate Document" (click)="openDocuments()">
          <ng-icon name="tablerFileText" class="ctrv3-action-icon"></ng-icon>
          <span class="ctrv3-doc-badge" *ngIf="totalMandatoryDocuments > 0 && !allVerified">
            {{totalMandatoryDocuments}}
          </span>
        </button>

        <!-- Contract Actions: all 3 step icons are shown to BOTH customer and supplier.
             Clicking is gated by role: the customer (contractContext === 'supplier')
             can Initiate Contract / Sign / Initiate WO; the supplier (contractContext ===
             'customer') can only Sign — the other two stay disabled but stay visible.
             Locked 2026-06-10 — green tick replacement removed. Each button keeps its
             ORIGINAL icon (tablerSend / sign-pen / tablerClipboardText) in all states;
             only the COLOR changes by state:
                Initial (not yet actionable, button disabled, not completed) → RED
                In Progress (enabled, awaiting click)                        → ORANGE
                Completed (done, button disabled, stays visible)             → GREEN
             Same icon throughout so the user reads the icon shape as the action type
             and the color as the state. -->
        <ng-container *ngIf="pageName === 'contract-candidates'">
          <!-- Tooltips are STATIC labels (locked 2026-06-15) — the icon shape and
               its color already communicate state (red=not yet actionable,
               orange=in progress, green=completed), so the tooltip stays
               anchored to the action's NAME and never switches phrasing. -->
          <button class="ctrv3-action-btn"
            title="Initiate Contract"
            *ngIf="contractContext === 'supplier'"
            (click)="onInitializeWorkOrderClick()"
            [disabled]="!initiateContractEnabled">
            <ng-icon class="ctrv3-action-icon"
              [ngClass]="getContractActionColorClass('initiate')"
              name="tablerSend"></ng-icon>
          </button>
          <button class="ctrv3-action-btn"
            title="Sign Contract"
            (click)="onSignContractClick()" [disabled]="!signContractEnabled">
            <span class="ctrv3-action-icon ctrv3-sign-icon"
              [ngClass]="getContractActionColorClass('sign')"></span>
          </button>
          <button class="ctrv3-action-btn"
            title="Initiate WorkOrder"
            *ngIf="contractContext === 'supplier'"
            (click)="onReleaseWorkOrderClick()"
            [disabled]="!initiateWOEnabled">
            <ng-icon class="ctrv3-action-icon"
              [ngClass]="getContractActionColorClass('wo')"
              name="tablerClipboardText"></ng-icon>
          </button>
        </ng-container>

        <!-- More Actions Dropdown (ngbDropdown with container="body") -->
        <div class="ctrv3-more-actions action-dropdown" ngbDropdown placement="bottom-right" container="body">
          <button class="ctrv3-action-btn" ngbDropdownToggle title="More Actions">
            <ng-icon name="tablerDotsVertical" class="ctrv3-action-icon"></ng-icon>
          </button>
          <div ngbDropdownMenu class="dropdown-menu-right">
            <!-- Download Resume -->
            <ng-container *ngIf="candidateval?.resumes?.length > 0">
              <ng-container *ngFor="let item of candidateval?.resumes">
                <button ngbDropdownItem *ngIf="item?.isDefault" (click)="downloadResume(candidateval, userId, item.fileId)">
                  <ng-icon name="tablerDownload"></ng-icon> Download Resume
                </button>
              </ng-container>
            </ng-container>
            <!-- Fallback: fetch resume on-demand when contract list API didn't return resumes -->
            <button ngbDropdownItem *ngIf="!candidateval?.resumes?.length" (click)="fetchAndDownloadResume(candidateval)">
              <ng-icon name="tablerDownload"></ng-icon> Download Resume
            </button>

            <!-- Event Log (cursor-paginated audit trail of contract lifecycle) -->
            <button ngbDropdownItem *ngIf="pageName === 'contract-candidates'" (click)="openEventLog.emit(candidateval)">
              <ng-icon name="tablerHistory"></ng-icon> Event Log
            </button>

            <!-- Contract Actions (Initiate Contract / Sign Contract / Initiate WO) are
                 handled by the inline row icons above; intentionally not duplicated here. -->
          </div>
        </div>
      </div>
    </div>

  </div>
</ng-container>

<ng-template #noResult>
  <div class="wert">
    <div class="col-md-12 mg-bt-9">
      <!-- <img style=" max-height: 9rem;" src="assets/icon/nothing_found.png" alt=""> -->
      <ng-icon name="tablerZoomQuestion"></ng-icon>
    </div>
    <!-- <div style="visibility: visible;" id="fetching" class="col-md-12 fig1">Fetching Jobs... </div>
      <div style="visibility: hidden;" id="zerocandidates" class="col-md-12 fig">Couldn't find any Jobs. </div> -->
    <div class="col-md-12 fig">{{candidatesFoundStatus}} </div>
  </div>
</ng-template>
<app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage($event)" [messageDataPass]="messageData">
</app-message-widget>
<ng-template #checkCredit>
  <div class="custom-panel-heading">
    <div class="panel-heading">
      <div class="row panel-tools">
        <div class="col-sm-2">
          <button id="candidate_card_close_insufficient_credits_modal_button" type="button" class="close" aria-label="Close" (click)="closemodel()">
            <span style="font-size: 26px;font-weight: 400;" aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>

      <label class="control-label padding-top-0 margin-bottom-5 margin-top-5"
        style="margin-left: 8px !important">Insufficient Credits</label>
    </div>

  </div>

  <div class="panel-body custom-modal-body">
    <div class="form-group row">
      <div class="row alrt-dngr" style="width:555px;margin-left:20px;">
        <div class="alert alert-danger addd-dngr" role="alert">
          You do not have enough credits. Please, purchase credits to proceed.
        </div>
      </div>

      <div class="row form-group text-center">
        <img src="assets/icon/not-enough-credits.jpg" alt="" srcset="" class="nocredits" />
      </div>
    </div>
  </div>
  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="shifu">
        <button id="candidate_card_purchase_credits_button" class="btn  btn-primary mlr-42" type="submit" (click)="purchesCredits(buyCredit)">Purchase
          Credits</button>
        <button id="candidate_card_cancel_credits_button" class="btn btn-default" (click)="closemodel()">Cancel</button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #buyCredit>

  <ng-container *ngIf="envName!='prod'">
    <div class="custom-panel-heading">
      <div class="panel-heading">
        <div class="row panel-tools">
          <div class="col-sm-2">
            <button id="candidate_card_close_buy_credit_modal_button" type="button" class="close" aria-label="Close" (click)="closemodel()">
              <span style="font-size: 26px;font-weight: 400;" aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>

        <label class="control-label padding-top-0 margin-bottom-5 margin-top-5" style="margin-left: 8px !important">Buy
          credit </label>
      </div>

    </div>
    <div class="panel-body custom-modal-body">
      <ng-container>
        <div class="list-group app-form">
          <form [formGroup]="creditform">
            <div class="form-group"> <label style="margin-top: 10px;" class="col-sm-4 m-t-6 control-label text-right">
                Buy credit </label>
              <div class="col-sm-5">
                <input type="text" formControlName="point" #input OnlyNumber="true" placeholder="Enter Point"
                  class="form-control">
                <!-- <input matInput formControlName="point" placeholder="Enter Point" #input  OnlyNumber="true"> -->
                <!-- <span *ngIf="submited && credit.point.errors?.required" style="color:red"> Enter credit Point</span>
                <span *ngIf="!submited && credit.point.errors?.required && credit.point.touched" style="color:red">
                  Enter credit Point</span> -->
                <div class="error-msg">
                  <span *ngIf="submited && credit.point.errors?.required" style="color:red"> Enter credit points</span>
                  <span *ngIf="!submited && credit.point.errors?.required && credit.point.touched" style="color:red">
                    Enter credit points</span>
                  <span *ngIf="submited && credit.point.errors?.pattern"> This value cannot start with zero</span>
                </div>


              </div>
            </div>
            <button id="candidate_card_buy_credit_button" type="button" class="btn btn-primary" (click)="buycredit('noval')"> Buy </button>
          </form>
          <div class="panel-body pointsSelectWp" style="margin-top: 31px;">
            <p class="text-center m-b-15"><b>(OR)</b></p>
            <p class="text-center">
              Select Credit points
            </p>
            <div class="poinstsCnt">
              <button id="candidate_card_buy_10_credits_button" class="btn btn-primary" (click)="buycredit('10')" type="button">10</button>
              <button id="candidate_card_buy_50_credits_button" class="btn btn-primary" (click)="buycredit('50')" type="button">50</button>
              <button id="candidate_card_buy_100_credits_button" class="btn btn-primary" (click)="buycredit('100')" type="button">100</button>
              <button id="candidate_card_buy_200_credits_button" class="btn btn-primary" (click)="buycredit('200')" type="button">200</button>
              <button id="candidate_card_buy_500_credits_button" class="btn btn-primary" (click)="buycredit('500')" type="button">500</button>
              <button id="candidate_card_buy_1000_credits_button" class="btn btn-primary" (click)="buycredit('1000')" type="button">1000</button>
            </div>

          </div>

        </div>
      </ng-container>
    </div>
  </ng-container>


</ng-template>
<ng-template #connectionTemplate>
  <app-connection-template [page]="'candidate-card'" [connectionStatus]="connectionStatus"
    [counterpartsDetails]="counterpartsDetails" [values]="values" [module]="'candidate'"></app-connection-template>
</ng-template>
<ng-template #jobsupplytemplate>
  <!-- Dynamic component container for NewJobComponent (circular dependency fix) -->
  <!-- Using div with ID so we can query it from the modal's DOM after modal renders -->
  <div #newJobContainer id="newJobDynamicContainerCandidateCard"></div>
</ng-template>

<!-- Interview Payrate Modal (for INTERVIEW-SCHEDULED / bypass stages) -->
<ng-template #interviewPayrateTemplate>

  <div class="common-header-flex">
    <div> Rate Confirmation </div>
    <button>
      <span (click)="hidePayrateModal()" class="common-close">&times;</span>
    </button>
  </div>

  <div class="col-sm-12 p-0 white">
    <div class="col-sm-12 p-0">

      <div [formGroup]="rtrformgrp">
        <div class="RtrForm payrate-two-row">

          <!-- Row 1 — Submitted for (read-only ceiling from the viewer's tier) -->
          <div class="payrate-row">
            <div class="payrate-row-label">Submitted for</div>
            <div class="targetRate">
              <input type="text" class="form-control input-sm payrate-readonly"
                     formControlName="submittedToRate" readonly tabindex="-1" />
            </div>
            <div class="paytype">
              <select class="form-control input-sm payrate-readonly"
                      formControlName="submittedRateType" disabled tabindex="-1">
                <option value="Hourly">Hourly</option>
                <option value="Daily">Daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Monthly">Monthly</option>
                <option value="Yearly">Yearly</option>
              </select>
            </div>
          </div>

          <!-- Row 2 — Offer for (editable, persisted as targetRate + payType) -->
          <div class="payrate-row">
            <div class="payrate-row-label">Offer for</div>
            <div class="targetRate">
              <input maxlength="8" (keypress)="isInteger($event)" type="text"
                class="form-control input-sm" formControlName="offerRate" placeholder="Ex: 10000.."/>
              <span *ngIf="rtrFormControls.offerRate.errors?.required &&
                (rtrFormControls.offerRate?.dirty || rtrFormControls.offerRate?.touched || submitRTR)" class="error">Please enter the value</span>
              <span *ngIf="rtrFormControls.offerRate.errors?.invalidDecimal" class="error">Enter valid offer rate</span>
              <span *ngIf="rtrFormControls.offerRate.errors?.max" class="error">
                Offer cannot exceed submitted ceiling of {{ rtrformgrp.get('submittedToRate')?.value }}
              </span>
            </div>
            <div class="paytype">
              <select formControlName="offerRateType" class="form-control input-sm">
                <option value="Hourly">Hourly</option>
                <option value="Daily">Daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Monthly">Monthly</option>
                <option value="Yearly">Yearly</option>
              </select>
              <span class="error" *ngIf="rtrFormControls.offerRateType.errors?.required &&
                (rtrFormControls.offerRateType?.dirty || rtrFormControls.offerRateType?.touched || submitRTR)">Please select pay type</span>
            </div>
          </div>

          <div class="currency">
            <span *ngIf="appliedJobDetails?.country === 'US'"> USD </span>
            <span *ngIf="appliedJobDetails?.country === 'IN'"> INR </span>
            <span *ngIf="appliedJobDetails?.country === 'CA'"> CAD </span>
            <span *ngIf="appliedJobDetails?.country === 'AU'"> AUD </span>
          </div>

          <div class="tAndCdesign">
            <div class="custom-checkbox em">
              <label class="checkbox-label font-normal" style="text-align: center">
                I confirm the entered pay rate is accurate and approved for this candidate
                <input type="checkbox" class="termsCondition" formControlName="termsandcondition" id="interviewTermsCheckBox" />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>

        </div>
        <div class="t-c-error-msg"
          *ngIf="rtrFormControls.termsandcondition.invalid && (rtrFormControls.termsandcondition.touched || submitRTR)">
          Please acknowledge the rate confirmation to proceed
        </div>
      </div>

    </div>
  </div>

  <div class="custom-panel-footer col-sm-12 p-0">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default " (click)="hidePayrateModal()">Cancel </button>
        <button class="btn  btn-primary " (click)="submitPayrate()"> Submit </button>
      </div>
    </div>
  </div>

</ng-template>

<!-- RTR Payrate Modal for OFFERED status -->
<ng-template #payrateTemplate>

  <div class="common-header-flex">
    <div> Rate Confirmation </div>
    <button>
      <span (click)="hidePayrateModal()" class="common-close">&times;</span>
    </button>
  </div>

  <div class="col-sm-12 p-0 white">
    <div class="col-sm-12 p-0">

      <div [formGroup]="rtrformgrp">
        <div class="RtrForm payrate-two-row">

          <div class="payrate-row">
            <div class="payrate-row-label">Submitted for</div>
            <div class="targetRate">
              <input type="text" class="form-control input-sm payrate-readonly"
                     formControlName="submittedToRate" readonly tabindex="-1" />
            </div>
            <div class="paytype">
              <select class="form-control input-sm payrate-readonly"
                      formControlName="submittedRateType" disabled tabindex="-1">
                <option value="Hourly">Hourly</option>
                <option value="Daily">Daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Monthly">Monthly</option>
                <option value="Yearly">Yearly</option>
              </select>
            </div>
          </div>

          <div class="payrate-row">
            <div class="payrate-row-label">Offer for</div>
            <div class="targetRate">
              <input maxlength="8" (keypress)="isInteger($event)" type="text"
                class="form-control input-sm" formControlName="offerRate" placeholder="Ex: 10000.."/>
              <span *ngIf="rtrFormControls.offerRate.errors?.required &&
                (rtrFormControls.offerRate?.dirty || rtrFormControls.offerRate?.touched || submitRTR)" class="error">Please enter the value</span>
              <span *ngIf="rtrFormControls.offerRate.errors?.invalidDecimal" class="error">Enter valid offer rate</span>
              <span *ngIf="rtrFormControls.offerRate.errors?.max" class="error">
                Offer cannot exceed submitted ceiling of {{ rtrformgrp.get('submittedToRate')?.value }}
              </span>
            </div>
            <div class="paytype">
              <select formControlName="offerRateType" class="form-control input-sm">
                <option value="Hourly">Hourly</option>
                <option value="Daily">Daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Monthly">Monthly</option>
                <option value="Yearly">Yearly</option>
              </select>
              <span class="error" *ngIf="rtrFormControls.offerRateType.errors?.required &&
                (rtrFormControls.offerRateType?.dirty || rtrFormControls.offerRateType?.touched || submitRTR)">Please select pay type</span>
            </div>
          </div>

          <div class="currency">
            <span *ngIf="rtrformgrp.value?.country === 'US'"> USD </span>
            <span *ngIf="rtrformgrp.value?.country === 'IN'"> INR </span>
            <span *ngIf="rtrformgrp.value?.country === 'CA'"> CAD </span>
            <span *ngIf="rtrformgrp.value?.country === 'DZ'"> AUD </span>
          </div>

          <div class="tAndCdesign">
            <div class="custom-checkbox em">
              <label class="checkbox-label font-normal" style="text-align: center">
                I warrant that I have an exclusive right to represent this candidate for the
                applied position
                <input type="checkbox" class="termsCondition" formControlName="termsandcondition" id="termsCheckBoxs" />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>

        </div>
        <div class="t-c-error-msg"
          *ngIf="rtrFormControls.termsandcondition.invalid && (rtrFormControls.termsandcondition.touched || submitRTR)">
          Please accept to the above statement by checking it
        </div>
      </div>

    </div>
  </div>

  <div class="custom-panel-footer col-sm-12 p-0">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default " (click)="hidePayrateModal()">Cancel </button>
        <button class="btn  btn-primary " (click)="submitPayrate()"> Submit </button>
      </div>
    </div>
  </div>

</ng-template>

<app-candidate-documents
  *ngIf="showDocumentSection"
  [pageName]="documentPanelPageName"
  [isOpen]="showDocumentSection"
  [listOfDocuments]="typeOfDocuments"
  [candidateId]="candidateval.candidateId"
  [jobId]="jobId || candidateval?.contractData?.jobId"
  [count]="totalMandatoryDocuments ?? 0"
  [allDocumentsVerified]="allVerified"
  (close)="closeDocuments()"
  (save)="saveDocuments($event)"
  (dataChanged)="refreshDocumentData()">
</app-candidate-documents>

<app-match-percentage-details
  *ngIf="showPercentageDetails"
  [isOpen]="showPercentageDetails"
  [jobId]="appliedJobDetails?.jobId"
  [candidateId]="details?.candidateId"
  [pageFrom]="pageName"
  [organisationId]="details?.organisationId"
  (close)="closePercentageDetails()">
</app-match-percentage-details>
